import React, {
  act,
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Card,
  Tabs,
  Button,
  Descriptions,
  Tag,
  Space,
  Row,
  Col,
  Select,
  Typography,
  Input,
  Radio,
  Tooltip,
  DatePicker,
  Switch,
  Flex,
  List,
  TimePicker,
  message,
  Collapse,
  Badge,
  Modal,
} from "antd";
import {
  EditOutlined,
  CheckCircleOutlined,
  CloseOutlined,
  DeleteFilled,
  EyeFilled,
  DownloadOutlined,
  FileTextOutlined,
  FileTextTwoTone,
  WhatsAppOutlined,
  SearchOutlined,
  LeftOutlined,
  CaretRightOutlined,
  DoubleLeftOutlined,
  EyeOutlined,
  PlusOutlined,
  ExclamationOutlined,
} from "@ant-design/icons";
import { PatientDetailsFormProps } from "../../props/PatientDetailsProps";
import { Form } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useUserFunctionalities } from "../../utils/UserFunctionalities";
import { FormProps } from "antd";
import {
  formatDateAlongWithTime,
  formattedDateToISOStringWithDateIncrement,
  formattedDateWithTime,
  formattedDateWithTimeUstToIst,
} from "../../utils/globalUtils";
import dayjs, { Dayjs } from "dayjs";
import Title from "antd/es/typography/Title";
import Loader, { Spinner } from "../../utils/Spinners";
import { API_URL, ROUTES } from "../../utils/constants";
import { openBillAuditForMapping } from "../../utils/billAuditUrlUtils";
import { IReferralLetter } from "../../interfaces/IReferral";
import Timeline from "./Timeline";
import DocPreview from "./DocPreview";
import FloatingDrawer from "../../utils/documentDrawer";
import { AppDispatch, RootState } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPreAuthStepper,
  fetchStepperData,
  getVisitStageStates,
  setCurrentStep,
} from "../../models/preAuthSlice";
import { useChatSse, ChatNotificationPayload } from "../../hooks/useChatSse";
import { resetPreAuthClaimRes } from "../../models/preAuthClaimSlice";
import ConfirmModal from "../../utils/confirmModal";
import { errorMessage } from "../../utils/notificationUtils";
import ClaimIDManuallyId from "./PreAuth/ClaimIDManuallyId";
import ManualStatus from "./PreAuth/ManualStatusButton";
import ManualPortalStatus from "./PreAuth/ManualPortalStatusButton";
import { CollapseProps } from "antd";
import PreAuthIhxContainer from "../../containers/patient/PreAuthIhx/PreAuthIhxContainer";
import DischargeIhxContainer from "../../containers/patient/Discharge/Ihx/DischargeIhxContainer";
import ClaimIhxContainer from "../../containers/patient/Claim/Ihx/ClaimIhxContainer";
import PreAuthCghsContainer from "../../containers/patient/PreAuthCghs/PreAuthCghsContainer";
import DischargeCghsContainer from "../../containers/patient/Discharge/Cghs/DischargeCghsContainer";
import ViewQueryModal from "./Query/IHX/ViewQueryModal";
import UploadQueryModal from "./Query/IHX/UploadQueryModal";
import DeficiencyUploadModal from "./Query/IHX/DeficiencyUploadModal";
import ViewQueryDocumentDeficiencyModal from "./Query/IHX/ViewQueryDocumentDeficiencyModal";
import { UploadDocument } from "../../models/EnhancementSlice";
import { IDocumentFields } from "../../interfaces/ICase";
import FilePreviewModal from "./PreAuth-query/FilePreviewModal";
import QueryUploadedDocument from "../modals/QueryUploadedDocument";
import {
  assignedTo,
  deleteUploadedDocument,
  getAllStarhealthDocumentsData,
  updateAllDocumentsData,
} from "../../apis/patientService";
import { IPreAuthQueryReply } from "../../interfaces/IPreAuthQuery";
import {
  fetchQueries,
  replyResponseToQuery,
} from "../../models/preAuthQuerySlice";
import ViewQueryUploadedDocument from "./Query/IHX/ViewQueryUploadedDocument";
import DeficiencyFailedDocumentView from "./Query/IHX/DeficiencyFailedDocumentView";
import PatientDetailsQueryCardAllStages from "./Query/IHX/PatientDetailsQueryCardAllStages";
import ClaimCghsContainer from "../../containers/patient/Claim/CGHS/ClaimCghsContainer";
import PortalRegistrationCghsContainer from "../../containers/patient/Portal Registration/CGHS/PortalRegistrationCghsContainer";
import { getBasicDetails, getTimelineDetails } from "../../models/patientSlice";
import PreAuthEchsContainer from "../../containers/patient/PreAuthEchs/PreAuthEchsContainer";
import ClaimEchsContainer from "../../containers/patient/Claim/Echs/ClaimEchsContainer";
import PortalRegistrationStarHealthContainer from "../../containers/patient/Portal Registration/StarHealth/PortalRegistrationStarHealthContainer";
import PreAuthStarHealthContainer from "../../containers/patient/PreAuth/StarHealth/PreAuthStarHealthContainer";
import DischargeStarHealthContainer from "../../containers/patient/Discharge/StarHealth/DischargeStarHealthContainer";
import ClaimStarHealthContainer from "../../containers/patient/Claim/StarHealth/ClaimStarHealthContainer";
import DischargeEchsContainer from "../../containers/patient/DischargeEchs/DischargeEchsContainer";
import SettlementContainer from "../../containers/Settlement/SettlementContainer";
import BillAuditStageContainer from "../../containers/patient/BillAuditStage/BillAuditStageContainer";
import PortalRegistrationAyushmanContainer from "../../containers/patient/Portal Registration/Ayushman Bharat/PortalRegistrationAyushmanContainer";
import ClaimAyushmanContainer from "../../containers/patient/Claim/Ayushman Bharat/ClaimAyushmanContainer";
import PreAuthAyushmanContainer from "../../containers/patient/PreAuth/Ayushman Bharat/PreAuthAyushmanContainer";
import PreAuthHealthIndiaContainer from "../../containers/patient/PreAuth/HealthIndia/PreAuthHealthIndiaContainer";
import PreAuthHeritageContainer from "../../containers/patient/PreAuth/Heritage/PreAuthHeritageContainer";
import PreAuthFhplContainer from "../../containers/patient/PreAuth/FHPL/PreAuthFhplContainer";
import PreAuthCghsContainerNew from "../../containers/patient/PreAuthCghs/PreAuthCghsNewContainer";
import DischargeCghsNewContainer from "../../containers/patient/Discharge/Cghs/DischargeCghsNewContainer";
import PortalRegistrationNewCghsContainer from "../../containers/patient/Portal Registration/CGHS/PortalRegistrationNewCghsContainer";
import ClaimCghsNewContainer from "../../containers/patient/Claim/CGHS/ClaimCghsNewContainer";
import ReferralAcceptanceContainer from "../../containers/patient/Referral Acceptance/ReferralAcceptanceContainer";
import { resetAvailableDoctors } from "../../models/doctorSlice";
import ViewResubmissionContainerCghsNew from "../../containers/patient/Resubmission/CGHS/ViewResubmissionContainerCghsNew";
import { Upload } from "antd";
import PatientDetailsStageDocument from "../modals/PatientDetailsStageDocument";
import {
  dispatchHeritageOrHealthIndiaPortalData,
  resolvePortalDisplayClaimId,
} from "../../utils/heritageHealthIndiaClaimId";
import { getSchemeDisplayName } from "../../utils/schemeDisplay";
// import PortalActiveInActiveModal from "./PortalActiveInActiveModal";

const { TabPane } = Tabs;

const modalBaseConfig = {
  centered: true,
  closable: false,
  maskClosable: false,
  width: 460,
  bodyStyle: { padding: "16px 12px 12px" },
  zIndex: 2500,
};

const containerStyle = {
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center",
  textAlign: "center" as const,
};

const iconWrapperStyle = (color: string) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 52,
  height: 52,
  borderRadius: "50%",
  border: `2px solid ${color}`,
  boxShadow: `0 0 12px ${color}66`,
  marginBottom: 16,
});

const titleStyle = {
  fontWeight: 700,
  fontSize: 18,
  marginBottom: 8,
  textTransform: "uppercase" as const,
};

const contentStyle = {
  fontSize: 16,
  fontWeight: 500,
  color: "#595959",
  marginBottom: 24,
};

const footerStyle = {
  display: "flex",
  justifyContent: "center",
  gap: 12,
};

const okButtonStyle = (color: string) => ({
  minWidth: 100,
  backgroundColor: color,
  borderColor: color,
  color: "#fff",
  fontWeight: 600,
});

const warningMessageModal = (message: string): void => {
  Modal.confirm({
    ...modalBaseConfig,
    icon: null,
    content: (
      <div style={containerStyle}>
        <div style={iconWrapperStyle("#faad14")}>
          <ExclamationOutlined style={{ fontSize: 24, color: "#faad14" }} />
        </div>

        <div style={titleStyle}>WARNING</div>
        <div style={contentStyle}>{message}</div>
      </div>
    ),
    okText: "OK",
    footer: (_, { OkBtn }) => (
      <div style={footerStyle}>
        <OkBtn />
      </div>
    ),
    okButtonProps: {
      style: okButtonStyle("#faad14"),
    },
  });
};

type Department = {
  name: string;
  description: string;
};

type ComponentDetail = {
  id: number;
  name: string;
  validUpto: string; // Adjust type as needed
  remarks?: string;
  maxQty?: string;
  referralType: string;
};

type FieldType = {
  fullName?: string;
  dob?: string | undefined | null | Dayjs;
  age?: number | string;
  email?: string;
  prefix?: string;
  primaryMobile?: string;
  secondaryMobile?: string;
  secondaryMobileOnWhatsApp?: boolean;
  sex?: string;
  status?: string;
  primaryMobileOnWhatsApp?: boolean;
  isPrimaryPolicyHolder?: boolean;
  communicationConsent?: boolean;
  primaryMobilePrefix?: string;
  hospitalId?: string | number;

  visitType?: string;
  dateTime?: string;
  opNumber?: string;
  department?: Array<string> | null;
  doa?: string | null | Dayjs;
  dod?: string | null;
  doctorDetails?: string;
  totalBillAmount?: string;
  roomNumber?: string;
  doctorId?: number | null;
  doctorName?: string;
  caseTypes?: string;
  patientSchemes?: string;
  uhidNo?: string;
  referralNo?: string;
  referralExpiryFrom?: string | null;
  referralExpiryTo?: string | null;
  noOfVisits?: string | null;
  referringDoctor?: string;
  referralFor?: string | null;
  referralType?: string | null;
  cardCategory?: string | null;
  cardNumber?: string;
  serviceNumber?: string;
  ariAndSC?: boolean;
  clinicalNotes?: string | null;
  admission?: string | null;
  consultationFor?: string | null;
  investigation?: string | null;
  ipAllowed?: boolean;
  polyClinic?: string | null;
  beneficiaryId?: string;
  name?: string | null;
  refferenceID?: string | null;
  dateIssued?: string;
  tokenNumber?: string | null;
  gender?: string | null;
  timeIssued?: string | null;
  referralBy?: string | null;
  remark?: string | null;
  opIpNumber?: any;

  emergencyContactNo?: string | null;
  relationship?: string | null;
  emergencyContactDetail?: string | null;
  schemePolicyNumber?: string | null | undefined;
};

const PatientDetailsForm: FC<PatientDetailsFormProps> = ({
  flag,
  selectedPatient,
  readOnly,
  toggleReadOnly,
  upDateDetails,
  calculateAge,
  selectedHospital,
  isLoading,
  justify,
  clearReferralDetails,
  handleDeficiencyModal,
  closeDeficiencyModal,
  deficiencyModal,
  deficiencyQuestions,
  selectedDocument,
  handleDownloadDocument,
  previewDocumentUrl,
  showDoc,
  handleDoctorSearch,
  availableDoctor,
  searchLoading,
  handleNavigate,
  handleCreditClickModal,
  handleUpdatePatientScheme,
  handleUpdatePatientDetails,
  showModal,
  documentUrl,
  zoomLevel,
  handleZoomIn,
  handleZoomOut,
  getFileType,
  fetchStepper,
  handleActivateDeactivate,
  isActiveDeactiveModal,
  setIsActiveDeactiveModal,
  handleOk,
  handleCancelConfirmationModal,
  isSubmitting,
  isDownloadingDocument,
  newSteps,
  handleCreateEnhancement,
  handleCreateQuery,
  viewAddedEnhancement,
  handleSetActiveStage,
  handleResubmission,
  viewResubmission,
  handleCreateUnlistedProcedure,
  handleCreateExtensionOfStay,
  viewUnlistedProcedure,
  viewExtensionOfStay,
}) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [visitReferralForm] = Form.useForm();
  const [schemeForm] = Form.useForm();
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const { Title, Text } = Typography;
  const [age, setAge] = useState<number | null>(null);
  const navigate = useNavigate();
  const { hasFunctionality, reloadFunctionalities } = useUserFunctionalities();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isVisitEdit, setIsVisitEdit] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState<string>("1");
  const [isEditSchemeDetail, setIsEditSchemeDetail] = useState(false);
  const [schemeStatus, setSchemeStatus] = useState<string>("INACTIVE");
  const dispatch = useDispatch<AppDispatch>();
  const {
    patients,
    hospital,
    preAuth,
    auth,
    queries,
    enhancement,
    ayushBPreAuth,
  } = useSelector((state: RootState) => state);
  const cardCategoryList = ["General", "Semi Private", "Private"];

  const displayClaimId = useMemo(
    () =>
      resolvePortalDisplayClaimId({
        visitClaimId: selectedPatient?.visitInfoResponse?.claimId,
        portalData: preAuth?.portalData,
        ayushBPortalData: ayushBPreAuth?.portalData,
      }),
    [
      selectedPatient?.visitInfoResponse?.claimId,
      preAuth?.portalData,
      ayushBPreAuth?.portalData,
    ],
  );
  const { stepperData, currentStep, stageAllState } = useSelector(
    (state: RootState) => state.preAuth,
  );
  const currentStageDetails = stepperData?.currentVisitStage;
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const dischargeStage = stepperData?.visitStages?.find(
    (stage: any) => stage?.visitStage === "Discharge",
  );
  const preAuthStage = stepperData?.visitStages?.find(
    (stage: any) => stage?.visitStage === "PreAuth",
  );
  const claimIdGenerationStage = stepperData?.visitStages?.find(
    (stage: any) => stage?.visitStage === "ClaimId Generation",
  );

  const isDischargeSubmitted =
    dischargeStage?.state === "Submitted" ||
    dischargeStage?.state === "Initiated" ||
    dischargeStage?.state === "Manually Submitted" ||
    dischargeStage?.completed;

  const isPreauthSubmitted =
    preAuthStage?.state === "Submitted" ||
    preAuthStage?.state === "Initiated" ||
    preAuthStage?.state === "Manually Submitted" ||
    preAuthStage?.state?.toLowerCase() === "id generated" ||
    preAuthStage?.state?.toLowerCase()?.includes("verified");

  const isPreAuthCompleted = preAuthStage?.completed;
  const isClaimIdGenerationCompleted = claimIdGenerationStage?.completed;
  const [activeKey, setActiveKey] = useState<string | string[]>(
    currentStageDetails?.visitStageId?.toString() ||
      stepperData?.visitStages?.[0]?.visitStageId?.toString() ||
      "",
  );
  const [queryStageId, setQueryStageId] = useState<any>();

  const patientStagesCollapseStyle = React.useMemo(
    () => ({
      minHeight: "100%",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    }),
    [],
  );

  useEffect(() => {
    if (!activeKey && !replyQuery) {
      setActiveKey(
        currentStageDetails?.visitStageId?.toString() ||
          stepperData?.visitStages?.[0]?.visitStageId?.toString() ||
          "",
      );
    }
  }, [currentStageDetails?.visitStageId, stepperData?.visitStages]);

  //query
  const [replyQueryModal, setReplyQueryModal] = useState<boolean>(false);
  const [viewQueryModal, setViewQueryModal] = useState<boolean>(false);

  const [replyDeficiencyQueryModal, setReplyDeficiencyQueryModal] =
    useState<boolean>(false);
  const [viewDeficiencyQueryModal, setViewDeficiencyQueryModal] =
    useState<boolean>(false);

  const [viewedQuery, setViewedQuery] = useState<any>();
  const [replyQuery, setReplyQuery] = useState<any>();

  //sse
  const [sseData, setSseData] = useState<any>(null);
  const [sseUpdateCount, setSseUpdateCount] = useState(0);
  const [portalCurrentStatus, setPortalCurrentStatus] =
    useState<boolean>(false);
  const [portalInactiveModalOpen, setPortalInactiveModalOpen] =
    useState<boolean>(false);

  const [sseChatData, setSseChatData] = useState<any>(null);
  const sseUrl = `${API_URL}/api/sse/subscribe`;

  // const handleSseNotification = useCallback(
  //   (payload: ChatNotificationPayload) => {
  //     setSseChatData(payload);
  //   },
  //   [],
  // );

  // const visitId = selectedPatient?.visitInfoResponse?.id ?? "";

  // const { messageVisitId } = useChatSse({
  //   visitId,
  //   sseUrl,
  //   onNotification: handleSseNotification,
  //   userId: auth?.userEmail?.id
  // });

  useEffect(() => {
    const caseId = selectedPatient?.casesResponse?.id;
    const visitId = selectedPatient?.visitInfoResponse?.id;
    if (caseId && visitId) {
      dispatchHeritageOrHealthIndiaPortalData(
        dispatch,
        caseId,
        visitId,
        selectedPatient?.casesResponse,
      );
    }
  }, [
    selectedPatient?.casesResponse?.id,
    selectedPatient?.visitInfoResponse?.id,
    dispatch,
  ]);

  useEffect(() => {
    if (
      selectedPatient?.casesResponse?.id &&
      selectedPatient?.visitInfoResponse?.id
    ) {
      const caseId = selectedPatient.casesResponse.id;
      const visitId = selectedPatient.visitInfoResponse.id;
      const url = `${API_URL}/api/sse/subscribe/${caseId}-${visitId}`;
      const eventSource = new EventSource(url);

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event?.data);
          setSseData(data);
          setSseUpdateCount((prev) => prev + 1);
        } catch {
          setSseData(event?.data);
        }
      };

      eventSource.onerror = () => {
        eventSource.close();
      };

      return () => {
        eventSource.close();
      };
    }
  }, [
    selectedPatient?.casesResponse?.id,
    selectedPatient?.visitInfoResponse?.id,
  ]);

  useEffect(() => {
    setPortalCurrentStatus(
      selectedPatient?.visitInfoResponse?.isLoggedIn ?? false,
    );

    if (
      selectedPatient?.casesResponse?.healthCareId &&
      selectedPatient?.casesResponse?.schemeMetaDataId
    ) {
      try {
        const hospitalId = selectedPatient?.casesResponse?.healthCareId;
        const schemeId = selectedPatient?.casesResponse?.schemeMetaDataId;
        const portalLoginLogoutUrl = `${API_URL}/api/sse/subscribe/portalLoginLogout-${hospitalId}-${schemeId}`;
        const eventSource = new EventSource(portalLoginLogoutUrl);

        eventSource.onmessage = (event) => {
          try {
            const data = JSON.parse(event?.data);
            setPortalCurrentStatus(data);
          } catch {
            console.error("Error parsing SSE data", event?.data);
          }
        };

        eventSource.onerror = () => {
          console.error(
            `SSE connection error for schemeId: ${schemeId}, hospitalId: ${hospitalId}`,
          );
          eventSource.close();
        };

        return () => {
          eventSource.close();
        };
      } catch (error) {
        console.error("Error fetching Portal Status:", error);
      }
    }
  }, [
    selectedPatient?.casesResponse?.healthCareId,
    selectedPatient?.casesResponse?.schemeMetaDataId,
    selectedPatient?.visitInfoResponse?.isLoggedIn,
  ]);

  // Helper to get portal label/color
  const getPortalLabel = (active: boolean | null) => {
    if (active === null) return { text: "Portal: Unknown", color: "#A6A6A6" };
    return active
      ? { text: "Portal: Active", color: "#2E8B57" }
      : { text: "Portal: Inactive", color: "#D51E1E" };
  };

  const integratedWithPortal =
    selectedPatient?.casesResponse?.integratedWithPortal ||
    patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal;
  const isManualSubmission =
    integratedWithPortal === false ||
    integratedWithPortal === "Manual Submission";

  useEffect(() => {
    if (
      selectedPatient?.visitInfoResponse?.id &&
      !portalCurrentStatus &&
      !isManualSubmission
    ) {
      setPortalInactiveModalOpen(true);
    } else {
      setPortalInactiveModalOpen(false);
    }
  }, [
    selectedPatient?.visitInfoResponse?.id,
    portalCurrentStatus,
    isManualSubmission,
  ]);

  const handleReplyQueryModal = (query: any) => {
    setActiveKey("");
    if (query?.deficiencyQuery) {
      setReplyDeficiencyQueryModal(true);
    } else {
      setReplyQueryModal(true);
    }
    setReplyQuery(query);
  };

  const handleViewQueryModal = (query: any) => {
    if (query?.deficiencyQuery) {
      setViewDeficiencyQueryModal(true);
    } else {
      setViewQueryModal(true);
    }
    setViewedQuery(query);
  };

  const [isGovt, setIsGovt] = useState<boolean>(false);
  const currentActiveStage = stepperData?.visitStages?.find(
    (stage: any) =>
      stage?.visitStageId ===
      (typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0])),
  );

  useEffect(() => {
    handleSetActiveStage(activeKey);
  }, [activeKey]);

  // const customStatus =
  //     currentActiveStage?.step && currentStageDetails?.step
  //         ? currentActiveStage.step === currentStageDetails.step
  //           ? currentStageDetails.stateId
  //           : currentActiveStage.step > currentStageDetails.step
  //           ? 8
  //           : 4
  //         : null;

  const styles: Record<string, React.CSSProperties> = {
    mainContent: {
      // border: "0.4px solid rgb(87, 87, 87)",
      gap: "15px",
      borderRadius: "16px 16px 0 0",
      margin: "0px 0.5rem",
    },
    statusDesign: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "20px",
      minWidth: "auto",
      maxHeight: "36px",
    },
    borderDesign: {
      minHeight: "50px",
      // background: "rgb(243, 243, 243)",
      padding: "2px 35px",
      gap: "42px",
      borderRadius: "16px 16px 0px 0px",
      // borderBottom: "1px solid rgb(166, 166, 166)",
      border: "0.4px solid rgb(87, 87, 87)",
      fontWeight: "600",
      fontSize: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      background: "#004C8F",
      color: "white",
    },
    filledBtn: {
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      textTransform: "uppercase",
      color: "white",
      marginRight: "0.8rem",
    },
    blankBtn: {
      color: "#008B8B",
      background: "white",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      marginRight: "0.8rem",
    },
    updateBtn: {
      position: "sticky",
      top: 0,
      backgroundColor: "white",
      zIndex: 998,
      padding: "10px 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    intimateSubmitBtn: {
      background: "#008B8B",
      // float: "right",
      marginRight: "0.8rem",
    },
    saveBtn: {
      color: "white",
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
    editBtn: {
      color: "#008B8B",
      background: "white",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
  };

  const statusColors: any = {
    SETTLED: "#2E8B57",
    SUBMITTED: "#2E8B57",
    CANCELLED: "#D51E1E",
    DENIED: "#D51E1E",
    QUERY: "#D51E1E",
    ERROR: "#D51E1E",
    SAVED: "#FFA500",
    PENDING: "#FFA500",
    INITIATED: "#FFA500",
    OTHER: "#FFA500",
    APPROVED: "#2E8B57",
    "CLAIM ID GENERATED": "#2E8B57",
    "ID GENERATED": "#2E8B57",
    "MANUAL VERIFIED": "#2E8B57",
  };

  const getStatusKey = (sseData: string) => {
    if (!sseData) return "OTHER";

    const normalized = sseData.toLowerCase();

    if (normalized.includes("pending")) return "PENDING";
    if (normalized.includes("submitted")) return "SUBMITTED";
    if (normalized.includes("settled")) return "SETTLED";
    if (normalized.includes("approved")) return "APPROVED";
    if (normalized.includes("cancelled")) return "CANCELLED";
    if (normalized.includes("denied")) return "DENIED";
    if (normalized.includes("query")) return "QUERY";
    if (normalized.includes("error")) return "ERROR";
    if (normalized.includes("saved")) return "SAVED";
    if (normalized.includes("initiated")) return "INITIATED";

    return "OTHER";
  };

  useEffect(() => {
    if (
      selectedPatient?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "CGHS" ||
      selectedPatient?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "CAPF" ||
      selectedPatient?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "ECHS"
    ) {
      setIsGovt(true);
    }

    fetchDocuments();
  }, [selectedPatient]);

  const upperMessage =
    selectedPatient?.visitInfoResponse?.message?.toUpperCase() || "OTHER";
  const statusKey =
    Object.keys(statusColors).find((key) => upperMessage.includes(key)) ||
    "OTHER";

  const schemeStatusChange = (checked: boolean) => {
    setSchemeStatus(checked ? "ACTIVE" : "INACTIVE");
  };
  useEffect(() => {
    // Optionally reload functionalities when component mounts
    reloadFunctionalities();
  }, [reloadFunctionalities]);
  const onFinish: FormProps<FieldType>["onFinish"] = async (allValues) => {
    const { doctorDetails, ...values } = allValues;

    let updatedValues: any = {
      ...values,
      secondaryMobileOnWhatsApp:
        selectedPatient?.patientResponse?.secondaryMobileOnWhatsApp ||
        values.secondaryMobileOnWhatsApp,
      primaryMobileOnWhatsApp:
        selectedPatient?.patientResponse?.primaryMobileOnWhatsApp ||
        values.primaryMobileOnWhatsApp,
      status: selectedPatient?.patientResponse?.status,
      primaryMobilePrefix:
        selectedPatient?.patientResponse?.primaryMobilePrefix ||
        values.primaryMobilePrefix,
      dob: form.getFieldValue("dob")
        ? form.getFieldValue("dob") === "Invalid Date" ||
          form.getFieldValue("dob") === "NaN NaN NaN"
          ? formattedDateToISOStringWithDateIncrement(form.getFieldValue("dob"))
          : dayjs(values.dob).format("DD-MM-YYYY HH:mm:ss")
        : null,
      hospitalId: selectedHospital?.value,
      visitId:
        patients?.fetchBasicDetails?.visitInfoResponse?.id ||
        selectedPatient?.visitInfoResponse?.id,
      doa: values?.doa
        ? dayjs(values?.doa).format("DD-MM-YYYY HH:mm:ss")
        : null,
    };

    if (doctorDetails) {
      const [doctorId, doctorName] = doctorDetails.split(",");
      updatedValues = {
        ...updatedValues,
        doctorId: parseInt(doctorId.trim()) == 0 ? null : parseInt(doctorId),
        doctorName: doctorName.trim(),
      };
    } else {
      updatedValues = {
        ...updatedValues,
        doctorId: null,
        doctorName: doctorName,
      };
    }

    await upDateDetails(selectedPatient?.patientResponse?.id, updatedValues);
    setIsEdit(false);
    const patientIdForSave =
      patients?.fetchBasicDetails?.visitInfoResponse?.id ||
      selectedPatient?.visitInfoResponse?.id ||
      patients?.fetchBasicDetails?.patientResponse?.id ||
      selectedPatient?.patientResponse?.id ||
      selectedPatient?.casesResponse?.id;
    if (patientIdForSave) {
      const mapKey = "__patientDetails_is_edit_map__";
      const editMap = (globalThis as any)[mapKey] || {};
      editMap[patientIdForSave] = false;
      (globalThis as any)[mapKey] = editMap;
    } else {
      (globalThis as any).__patientDetails_is_edit__ = false;
    }
  };

  function convertDateFormat(dateString: string): string {
    const parsedDate = dayjs(dateString, "DD-MM-YYYY HH:mm:ss");
    return parsedDate.format("DD-MMM-YYYY");
  }

  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select
        style={{ width: 70 }}
        defaultValue={selectedPatient?.patientResponse?.primaryMobilePrefix}
      >
        <Option value="+91">+91</Option>
      </Select>
    </Form.Item>
  );

  const secondaryPrefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select
        style={{ width: 70 }}
        defaultValue={selectedPatient?.patientResponse?.secondaryMobilePrefix}
      >
        <Option value="+91">+91</Option>
      </Select>
    </Form.Item>
  );

  function formatDateForUI(inputDate: string): string {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Split the input date
    const [day, month, year] = inputDate.split(" ")[0].split("-");

    // Convert the month number to a month name
    const monthName = months[parseInt(month, 10) - 1];

    return `${parseInt(day, 10)} ${monthName}, ${year}`;
  }

  function formatDateForUIWithTime(input: string): string {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const [datePart, timePart] = input.split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);

    const date = new Date(year, month - 1, day, hour, minute);

    const monthName = months[date.getMonth()];
    const formattedTime = date
      .toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
      .replace(" ", "");

    return `${day} ${monthName}, ${year} ${formattedTime}`;
  }

  const handleSelectDoctor = (doctor: any) => {
    if (doctor?.id) {
      form.setFieldValue("doctorDetails", `${doctor.id},${doctor.fullName}`);
      setDoctorName(`${doctor.fullName}`);
    }
    setShowDropdown(false);

    form.validateFields(["doctorDetails"]);
  };

  const handleChange = (e: any) => {
    setDoctorName(e.target.value);
    if (!e.target.value) {
      setShowDropdown(false);
      dispatch(resetAvailableDoctors());
      form.setFieldValue("doctorDetails", null);
      form.validateFields(["doctorDetails"]);
      return;
    }
    if (e.target.value?.length <= 2) {
      setShowDropdown(false);
      dispatch(resetAvailableDoctors());
    }
    form.setFieldValue("doctorDetails", `${0},${e.target.value}`);
    form.validateFields(["doctorDetails"]);

    if (e.key === "Enter") {
      handleDoctorSearch(e.target.value);
    }
  };

  const handleSearchDoctor = () => {
    handleDoctorSearch(doctorName);
    setShowDropdown(true);
  };

  const [doctorName, setDoctorName] = useState<string>();
  const [showDropDown, setShowDropdown] = useState<boolean>(false);

  const [labelNameForVisit, setLabelNameForVisit] =
    useState<string>("IP/OP Number");
  const visitData = ["EMERGENCY", "IP", "OP"];
  const visitTypeList = visitData?.map((option) => ({
    value: option,
    label: option,
  }));

  const departmentOptions: {
    [key: string]: Department[];
  } = {
    medical_departments: [
      {
        name: "Emergency Department (ED) / Accident & Emergency (A&E)",
        description: "For urgent and emergency care.",
      },
      {
        name: "Internal Medicine",
        description:
          "Deals with the diagnosis and treatment of adult diseases.",
      },
      {
        name: "Cardiology",
        description: "Specializes in heart and blood vessel disorders.",
      },
      {
        name: "Neurology",
        description: "Focuses on disorders of the brain and nervous system.",
      },
      {
        name: "Gastroenterology",
        description:
          "Specializes in digestive system and gastrointestinal disorders.",
      },
      {
        name: "Nephrology",
        description: "Focuses on kidney function and diseases.",
      },
      {
        name: "Pulmonology",
        description: "Specializes in respiratory system diseases.",
      },
      {
        name: "Rheumatology",
        description:
          "Treats autoimmune and inflammatory diseases, particularly affecting the joints and muscles.",
      },
      {
        name: "Endocrinology",
        description:
          "Deals with hormone-related diseases, such as diabetes and thyroid disorders.",
      },
      {
        name: "Oncology",
        description: "Focuses on the diagnosis and treatment of cancer.",
      },
      {
        name: "Hematology",
        description: "Specializes in blood disorders and blood cancers.",
      },
      {
        name: "Dermatology",
        description: "Treats skin, hair, and nail disorders.",
      },
      {
        name: "Pediatrics",
        description:
          "Focuses on the medical care of infants, children, and adolescents.",
      },
      {
        name: "Geriatrics",
        description: "Focuses on health care for the elderly.",
      },
      {
        name: "Infectious Disease",
        description:
          "Specializes in the diagnosis and treatment of infectious diseases.",
      },
      {
        name: "Allergy and Immunology",
        description:
          "Deals with immune system disorders, allergies, and autoimmune diseases.",
      },
    ],
    surgical_departments: [
      {
        name: "General Surgery",
        description:
          "Performs a variety of surgical procedures on abdominal organs, thyroid, etc.",
      },
      {
        name: "Cardiothoracic Surgery",
        description: "Specializes in surgery of the heart, lungs, and chest.",
      },
      {
        name: "Neurosurgery",
        description:
          "Performs surgeries on the brain, spinal cord, and nervous system.",
      },
      {
        name: "Orthopedic Surgery",
        description:
          "Focuses on surgeries related to bones, joints, ligaments, tendons, and muscles.",
      },
      {
        name: "Vascular Surgery",
        description:
          "Treats diseases of the vascular system (arteries and veins).",
      },
      {
        name: "Plastic and Reconstructive Surgery",
        description: "Focuses on aesthetic and reconstructive surgeries.",
      },
      {
        name: "Otolaryngology (ENT)",
        description:
          "Specializes in surgery for ear, nose, and throat conditions.",
      },
      {
        name: "Urology",
        description:
          "Focuses on surgical treatments of the urinary tract and male reproductive organs.",
      },
      {
        name: "Others",
        description: "Others.",
      },
    ],
  };

  const departmentNames = Object.keys(departmentOptions).reduce(
    (acc: string[], category: string) => {
      const departments =
        departmentOptions[category as keyof typeof departmentOptions];
      const departmentNamesForCategory = departments.map((dept) => dept.name);
      return [...acc, ...departmentNamesForCategory];
    },
    [],
  );

  const departmentListOptions = departmentNames?.map((department) => {
    return {
      value: department,
      label: department,
    };
  });

  const handleToggle = () => {
    toggleReadOnly();
  };

  const initialValues: FieldType = {
    fullName: selectedPatient?.patientResponse?.fullName,
    dob:
      selectedPatient?.patientResponse?.dob &&
      dayjs(selectedPatient?.patientResponse?.dob, dateFormat, true).isValid()
        ? dayjs(convertDateFormat(selectedPatient?.patientResponse?.dob))
        : null,
    age: selectedPatient?.patientResponse?.age,
    email: selectedPatient?.patientResponse?.email,
    cardCategory: selectedPatient?.patientResponse?.cardCategory,
    prefix: selectedPatient?.patientResponse?.primaryMobilePrefix || "+91",
    primaryMobile: selectedPatient?.patientResponse?.primaryMobile,
    secondaryMobile: selectedPatient?.patientResponse?.secondaryMobile,
    secondaryMobileOnWhatsApp:
      selectedPatient?.patientResponse?.secondaryMobileOnWhatsApp,
    sex: selectedPatient?.patientResponse?.sex,
    status: selectedPatient?.patientResponse?.status,
    primaryMobileOnWhatsApp:
      selectedPatient?.patientResponse?.primaryMobileOnWhatsApp,
    communicationConsent:
      selectedPatient?.patientResponse?.communicationConsent || true,
    isPrimaryPolicyHolder:
      selectedPatient?.patientResponse?.isPrimaryPolicyHolder || true,
    hospitalId: selectedHospital?.value,
    uhidNo: selectedPatient?.patientResponse?.uhidNo,
    opIpNumber: selectedPatient?.visitInfoResponse?.opNumber,
    doa:
      selectedPatient?.visitInfoResponse?.doa &&
      dayjs(selectedPatient?.visitInfoResponse?.doa, dateFormat, true).isValid()
        ? dayjs(convertDateFormat(selectedPatient?.visitInfoResponse?.doa))
        : null,
  };

  useEffect(() => {
    const updatedValues = {
      fullName: selectedPatient?.patientResponse?.fullName,
      dob:
        selectedPatient?.patientResponse?.dob &&
        dayjs(selectedPatient?.patientResponse?.dob, dateFormat, true).isValid()
          ? dayjs(convertDateFormat(selectedPatient?.patientResponse?.dob))
          : null,
      age: selectedPatient?.patientResponse?.age,
      email: selectedPatient?.patientResponse?.email,
      cardCategory: selectedPatient?.patientResponse?.cardCategory,
      prefix: selectedPatient?.patientResponse?.primaryMobilePrefix || "+91",
      primaryMobile: selectedPatient?.patientResponse?.primaryMobile,
      secondaryMobile: selectedPatient?.patientResponse?.secondaryMobile,
      secondaryMobileOnWhatsApp:
        selectedPatient?.patientResponse?.secondaryMobileOnWhatsApp,
      sex: selectedPatient?.patientResponse?.sex,
      status: selectedPatient?.patientResponse?.status,
      primaryMobileOnWhatsApp:
        selectedPatient?.patientResponse?.primaryMobileOnWhatsApp,
      communicationConsent:
        selectedPatient?.patientResponse?.communicationConsent || true,
      isPrimaryPolicyHolder:
        selectedPatient?.patientResponse?.isPrimaryPolicyHolder || true,
      hospitalId: selectedHospital?.value,
      uhidNo: selectedPatient?.patientResponse?.uhidNo,
      opIpNumber: selectedPatient?.visitInfoResponse?.opNumber,
      department: selectedPatient?.visitInfoResponse?.department || null,
      doa:
        selectedPatient?.visitInfoResponse?.doa &&
        dayjs(
          selectedPatient?.visitInfoResponse?.doa,
          dateFormat,
          true,
        ).isValid()
          ? dayjs(convertDateFormat(selectedPatient?.visitInfoResponse?.doa))
          : null,
      doctorName: selectedPatient?.visitInfoResponse?.doctorName || "",
    };

    if (selectedPatient?.visitInfoResponse.doctorName) {
      setDoctorName(selectedPatient?.visitInfoResponse.doctorName);
      form.setFieldValue(
        "doctorDetails",
        `${selectedPatient?.visitInfoResponse.doctorId ?? 0},${selectedPatient?.visitInfoResponse.doctorName}`,
      );
      form.validateFields(["doctorDetails"]);
    }
    form.setFieldsValue(updatedValues);
  }, [selectedPatient]);

  useEffect(() => {
    if (selectedPatient?.visitInfoResponse !== null) {
      const updatedValues: any = {
        ...selectedPatient?.visitInfoResponse,
        visitType: selectedPatient?.visitInfoResponse?.visitType || "",
        doa:
          selectedPatient?.visitInfoResponse?.doa &&
          dayjs(
            selectedPatient?.visitInfoResponse?.doa,
            dateFormat,
            true,
          ).isValid()
            ? dayjs(
                selectedPatient?.visitInfoResponse?.doa?.toString(),
                dateFormat,
              )
            : null,
        dod:
          selectedPatient?.visitInfoResponse?.dod &&
          dayjs(
            selectedPatient?.visitInfoResponse?.dod,
            dateFormat,
            true,
          ).isValid()
            ? dayjs(
                selectedPatient?.visitInfoResponse?.dod?.toString(),
                dateFormat,
              )
            : null,
        department: selectedPatient?.visitInfoResponse?.department || null,
        opNumber:
          selectedPatient?.visitInfoResponse?.opNumber?.toString() || "",
        doctorDetails: visitReferralForm.getFieldValue("doctorDetails")
          ? visitReferralForm.getFieldValue("doctorDetails")
          : `${selectedPatient?.visitInfoResponse?.doctorId ?? ""},${
              selectedPatient?.visitInfoResponse?.doctorName ?? ""
            }`,
      };
      if (selectedPatient?.casesResponse?.schemeMetaDataName == "MEDI ASSIST") {
        updatedValues.roomNumber =
          selectedPatient?.visitInfoResponse?.roomNumber?.toString() || "";
        updatedValues.totalBillAmount =
          selectedPatient?.visitInfoResponse?.totalBillAmount?.toString() || "";
      }
      setDoctorName(`${selectedPatient?.visitInfoResponse?.doctorName ?? ""}`);
      visitReferralForm.setFieldsValue(updatedValues);
      setLabelNameForVisit(
        selectedPatient?.visitInfoResponse?.visitType === "OP"
          ? "OP Number"
          : "IP Number",
      );
    } else {
      visitReferralForm.setFieldsValue(initialValues);
      setDoctorName("");
    }
  }, [selectedPatient]);

  useEffect(() => {
    if (
      visitReferralForm.getFieldValue("doa") &&
      labelNameForVisit == "IP Number"
    ) {
      const suggestedDod = visitReferralForm
        .getFieldValue("doa")
        ?.clone()
        .add(5, "days");
      visitReferralForm.setFieldsValue({ dod: suggestedDod });
    } else if (
      visitReferralForm.getFieldValue("doa") &&
      labelNameForVisit == "OP Number"
    ) {
      const suggestedDod = visitReferralForm.getFieldValue("doa")?.clone();
      visitReferralForm.setFieldsValue({ dod: suggestedDod });
    }
  }, [labelNameForVisit]);

  useEffect(() => {
    if (doctorName && doctorName?.length > 3) {
      handleSearchDoctor();
    }
  }, [doctorName]);

  useEffect(() => {
    const dob = form.getFieldValue("dob");
    if (dob) {
      const age = calculateAge(dob);
      setAge(age || null);
    }
  }, [calculateAge, form]);

  useEffect(() => {
    if (age) form.setFieldsValue({ age });
  }, [age, form]);

  const maxDate = dayjs().format(dateFormat);

  const [documentName, setDocumentName] = useState("");

  const showErrorMessage = (combinedErrors: any) => {
    message.error({
      content: combinedErrors,
      duration: 5,
      style: {
        whiteSpace: "pre-wrap",
      },
    });
  };

  const handleFinishFailed = (errorInfo: any) => {
    const errorData = errorInfo.errorFields;
    const combinedErrors = errorData
      ?.map((item: any) => item.errors.join(", "))
      ?.join("\n");

    showErrorMessage(combinedErrors);
  };

  useEffect(() => {
    return () => {
      message.destroy();
    };
  }, []);

  const handleVisitReferral: FormProps<FieldType>["onFinish"] = async (
    values: any,
  ) => {
    const { doctorDetails, ...restValues } = values;
    const stringTimeIssued = dayjs(values?.timeIssued).format("hh:mm:ss");

    const data = services?.map((item, index) => ({
      id: item?.id,
      name: item.name,
      validUpto: item?.validUpto,
      remarks: values[`services[${index}].remarks`] || item.remarks || "",
      maxQty: item.maxQty || "NA",
      referralType: item.referralType || "",
    }));
    let formattedValues = {
      ...restValues,
      doa: values.doa ? dayjs(values.doa).format(dateFormat) : undefined,
      dod: values.dod ? dayjs(values.dod).format(dateFormat) : undefined,
      referralExpiryFrom: dayjs(values?.referralExpiryFrom).format(
        "DD-MM-YYYY",
      ),
      referralExpiryTo: dayjs(values?.referralExpiryTo).format("DD-MM-YYYY"),
      dateIssued: formattedDateToISOStringWithDateIncrement(values?.dateIssued),
      timeIssued: stringTimeIssued,
      services: data,
      status: "ACTIVE",
    };
    if (doctorDetails) {
      const [doctorId, doctorName] = doctorDetails.split(",");
      formattedValues = {
        ...formattedValues,
        doctorId: doctorId ? parseInt(doctorId.trim()) : null,
        doctorName: doctorName.trim(),
      };
    }
    const referralInfoRequest = {
      echsReferralRequest: null,
      cghsReferralRequest: null,
    };
    if (
      selectedPatient?.casesResponse?.schemeMetaDataName
        ?.toLowerCase()
        ?.includes("cghs") ||
      selectedPatient?.casesResponse?.schemeMetaDataName
        ?.toLowerCase()
        ?.includes("capf")
    ) {
      const referralDocument = {
        documentType:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse
            ?.documentType,
        documentUrl:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse
            ?.documentUrl,
        documentName:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse
            ?.documentName,
        id: selectedPatient?.referralInfoResponse?.cghsReferralResponse
          ?.documentId,
      };
      referralInfoRequest.cghsReferralRequest = {
        ...values,
        id: selectedPatient?.referralInfoResponse?.cghsReferralResponse?.id,
        document: referralDocument,
        services: data,
        schemeId: selectedPatient?.casesResponse?.schemeMetaDataId,
        dateIssued:
          values?.dateIssued && values?.dateIssued !== ""
            ? dayjs(values?.dateIssued).format("DD-MM-YYYY")
            : null,
        timeIssued: stringTimeIssued,
        beneficiaryId: values?.beneficiaryId,
        name: values?.name || values?.fullName,
        age: values?.age,
        gender: values?.sex || values?.gender,
      };
    } else {
      const referralDocument = {
        documentType:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.documentType,
        documentUrl:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.documentUrl,
        documentName:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.documentName,
        id: selectedPatient?.referralInfoResponse?.echsReferralResponse
          ?.documentId,
      };
      referralInfoRequest.echsReferralRequest = {
        ...values,
        id: selectedPatient?.referralInfoResponse?.echsReferralResponse?.id,
        document: referralDocument,
        schemeId: selectedPatient?.casesResponse?.schemeMetaDataId,
        referralNo: values?.referralNo,
        name: values?.name || values?.fullName,
        age: values?.age,
        gender: values?.sex || values?.gender,
        referralExpiryFrom:
          values?.referralExpiryFrom && values?.referralExpiryFrom !== ""
            ? dayjs(values?.referralExpiryFrom).format("DD-MM-YYYY")
            : null,
        referralExpiryTo:
          values?.referralExpiryTo && values?.referralExpiryTo !== ""
            ? dayjs(values?.referralExpiryTo).format("DD-MM-YYYY")
            : null,
      };
    }
    const newValues = {
      caseId: selectedPatient?.casesResponse?.id,
      patientId: patients?.fetchBasicDetails?.patientResponse?.id,
      referralInfoId: selectedPatient?.referralInfoResponse
        ?.cghsReferralResponse
        ? selectedPatient?.referralInfoResponse?.cghsReferralResponse?.id
        : selectedPatient?.referralInfoResponse?.echsReferralResponse
          ? selectedPatient?.referralInfoResponse?.echsReferralResponse?.id
          : null,
      visitInfoId: selectedPatient?.visitInfoResponse?.id,
      patientRequest: {
        patientSchemeDetails: {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          identityNumber:
            values?.beneficiaryId ||
            selectedPatient?.patientResponse?.patientSchemeNewResponseList?.[0]
              ?.schemePolicyNumber,
        },
      },
      referralInfoRequest,
      visitInfoRequest: {
        ...selectedPatient?.visitInfoResponse,
        id: selectedPatient?.visitInfoResponse?.id,
        ...formattedValues,
        emergencyContactDetail: values?.emergencyContactDetail?.trim(),
        relationship: values?.relationship?.trim(),
        emergencyContactNo: values?.emergencyContactNo,
        status:
          selectedPatient?.visitInfoResponse?.status === false ? false : true,
      },
    };

    await handleUpdatePatientDetails(newValues);
    setIsVisitEdit(false);
    // handleUpdatePatient(newValues);
  };

  useEffect(() => {
    const patientId =
      patients?.fetchBasicDetails?.visitInfoResponse?.id ||
      selectedPatient?.visitInfoResponse?.id ||
      patients?.fetchBasicDetails?.patientResponse?.id ||
      selectedPatient?.patientResponse?.id ||
      patients?.fetchBasicDetails?.casesResponse?.id ||
      selectedPatient?.casesResponse?.id;

    if (!patientId) return;

    const warningMapKey = "__patientDetails_warning_shown_map__";
    const editMapKey = "__patientDetails_is_edit_map__";

    const warningMap = (globalThis as any)[warningMapKey] || {};
    const editMap = (globalThis as any)[editMapKey] || {};

    const hasShownForPatient = !!warningMap[patientId];

    if (
      patients?.fetchBasicDetails?.patientResponse?.uhidNo === "-" &&
      !hasShownForPatient
    ) {
      // mark as shown for this patient only
      (globalThis as any)[warningMapKey] = {
        ...(globalThis as any)[warningMapKey],
        [patientId]: true,
      };
      (globalThis as any)[editMapKey] = {
        ...(globalThis as any)[editMapKey],
        [patientId]: true,
      };
      setIsEdit(true);
      warningMessageModal("Please, Update All the Necessary Details");
    } else {
      // sync isEdit from the per-patient map
      setIsEdit(!!editMap[patientId]);
    }
  }, [
    patients?.fetchBasicDetails?.patientResponse?.uhidNo,
    patients?.fetchBasicDetails?.patientResponse?.id,
    selectedPatient?.patientResponse?.id,
  ]);

  useEffect(() => {
    const updatedValues = {
      status:
        selectedPatient?.patientResponse?.patientSchemeNewResponseList?.[0]
          ?.status === "ACTIVE",
      schemePolicyNumber:
        selectedPatient?.patientResponse?.patientSchemeNewResponseList?.[0]
          ?.schemePolicyNumber,
    };
    schemeForm.setFieldsValue(updatedValues);
  }, [selectedPatient, schemeForm]);

  const handleSubmitScheme: FormProps<FieldType>["onFinish"] = async (
    values,
  ) => {
    const updatedValues: FieldType = {
      ...selectedPatient?.patientResponse?.patientSchemeNewResponseList?.[0],
      ...values,
      status: schemeForm.getFieldValue("status") ? "ACTIVE" : "INACTIVE",
    };

    await handleUpdatePatientScheme({
      ...updatedValues,
      schemeUpdateId:
        selectedPatient?.patientResponse?.patientSchemeNewResponseList?.[0]?.id,
    });
    setIsEditSchemeDetail(false);
    // schemeForm.resetFields();
    // schemeForm.setFieldValue("status", false);
  };

  const handleEditPatient = () => {
    const newVal = !isEdit;
    setIsEdit(newVal);
    const patientId =
      patients?.fetchBasicDetails?.patientResponse?.id ||
      selectedPatient?.patientResponse?.id ||
      patients?.fetchBasicDetails?.casesResponse?.id ||
      selectedPatient?.casesResponse?.id;
    if (patientId) {
      const editMapKey = "__patientDetails_is_edit_map__";
      const editMap = (globalThis as any)[editMapKey] || {};
      editMap[patientId] = newVal;
      (globalThis as any)[editMapKey] = editMap;
    } else {
      (globalThis as any).__patientDetails_is_edit__ = newVal;
    }
  };

  const handleEditVisitReferral = () => {
    setIsVisitEdit(!isVisitEdit);
  };

  const [services, setServices] = useState<ComponentDetail[]>([]);
  const [servicesState, setServicesState] = useState(services);

  useEffect(() => {
    setServicesState(services);
  }, [services]);

  const handleServiceChange = (index: any, field: any, value: any) => {
    const updatedServices = [...servicesState];
    updatedServices[index] = { ...updatedServices[index], [field]: value };
    setServicesState(updatedServices);
    setServices(updatedServices);
  };

  const constructServices = (fetchReferralDetail: IReferralLetter | null) => {
    if (!fetchReferralDetail) return [];
    const services =
      fetchReferralDetail?.services ??
      fetchReferralDetail?.referralServicesResponses;

    return services?.map((service: any) => ({
      id: service?.id,
      referralType: service?.referralType,
      name: service?.name,
      remarks: service?.remarks,
      validUpto: service?.validUpto,
      maxQty: service?.maxQty,
    }));
  };

  useEffect(() => {
    if (selectedPatient?.referralInfoResponse?.cghsReferralResponse) {
      const updatedValues = {
        beneficiaryId:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse
            ?.beneficiaryId,
        name: selectedPatient?.referralInfoResponse?.cghsReferralResponse?.name,
        age: selectedPatient?.referralInfoResponse?.cghsReferralResponse?.age,
        refferenceID:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse
            ?.refferenceID,
        remark:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse?.remark,
        referralBy:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse
            ?.doctorName ||
          selectedPatient?.referralInfoResponse?.cghsReferralResponse
            ?.referralBy,
        dateIssued:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse
            ?.dateIssued &&
          dayjs(
            selectedPatient?.referralInfoResponse?.cghsReferralResponse
              ?.dateIssued,
            "DD-MM-YYYY",
            true,
          ).isValid()
            ? dayjs(
                selectedPatient?.referralInfoResponse?.cghsReferralResponse
                  ?.dateIssued,
                "DD-MM-YYYY",
              )
            : null,
        tokenNumber:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse
            ?.tokenNumber,
        gender:
          selectedPatient?.referralInfoResponse?.cghsReferralResponse?.gender,
        timeIssued: selectedPatient?.referralInfoResponse?.cghsReferralResponse
          ?.timeIssued
          ? dayjs(
              selectedPatient?.referralInfoResponse?.cghsReferralResponse
                ?.timeIssued,
              "hh:mm:ss",
            )
          : null,
      };
      visitReferralForm.setFieldsValue(updatedValues);
      const servicesData = constructServices(
        selectedPatient?.referralInfoResponse?.cghsReferralResponse,
      );
      setServices(servicesData);
    }
  }, [
    selectedPatient?.referralInfoResponse?.cghsReferralResponse,
    visitReferralForm,
  ]);

  useEffect(() => {
    if (selectedPatient?.referralInfoResponse?.echsReferralResponse) {
      const updatedValues = {
        referralNo:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.referralNo,
        referralExpiryFrom:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.referralExpiryFrom &&
          dayjs(
            selectedPatient?.referralInfoResponse?.echsReferralResponse
              ?.referralExpiryFrom,
            "DD-MM-YYYY",
            true,
          ).isValid()
            ? dayjs(
                selectedPatient?.referralInfoResponse?.echsReferralResponse
                  ?.referralExpiryFrom,
                "DD-MM-YYYY",
              )
            : null,
        referralExpiryTo:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.referralExpiryTo &&
          dayjs(
            selectedPatient?.referralInfoResponse?.echsReferralResponse
              ?.referralExpiryTo,
            "DD-MM-YYYY",
            true,
          ).isValid()
            ? dayjs(
                selectedPatient?.referralInfoResponse?.echsReferralResponse
                  ?.referralExpiryTo,
                "DD-MM-YYYY",
              )
            : null,
        noOfVisits:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.noOfVisits || "",
        referringDoctor:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.referringDoctor || "",
        referralFor:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.referralFor || "",
        referralType:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.referralType || "",
        cardCategory:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.cardCategory || "",
        cardNumber:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.cardNumber || "",
        serviceNumber:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.serviceNumber || "",
        ariAndSC:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.ariAndSC || false,
        clinicalNotes:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.clinicalNotes || "",
        admission:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.admission || "",
        consultationFor:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.consultationFor || "",
        investigation:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.investigation || "",
        ipAllowed:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.ipAllowed || false,
        polyClinic:
          selectedPatient?.referralInfoResponse?.echsReferralResponse
            ?.polyClinic || "",
      };
      visitReferralForm.setFieldsValue(updatedValues);
    }
  }, [
    selectedPatient?.referralInfoResponse?.echsReferralResponse,
    visitReferralForm,
  ]);

  const handleFetchStepper = () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      dispatch(fetchPreAuthStepper({ caseId: caseId, visitId: visitId }));
    }
  };

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        }),
      );
    }
  };

  const renderMoreDetails = () => {
    const cghsResponse =
      selectedPatient?.referralInfoResponse?.cghsReferralResponse;
    const echsResponse =
      selectedPatient?.referralInfoResponse?.echsReferralResponse;

    const services =
      selectedPatient?.referralInfoResponse?.cghsReferralResponse?.services ??
      selectedPatient?.referralInfoResponse?.cghsReferralResponse
        ?.referralServicesResponses;

    if (cghsResponse) {
      return (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              backgroundColor: "#EFF6FF",
              border: "0.4px solid #A6A6A6",
              borderRadius: "10px",
              padding: "14px 20px 14px 20px",
              marginTop: "0.5rem",
              boxShadow: "0px -1px 4px 0px #00000040 inset",
            }}
          >
            {/* Beneficiary ID */}
            <div
              className="items"
              style={{
                // padding: "10px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "24%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Beneficiary ID
              </p>
              <Tooltip title={cghsResponse?.beneficiaryId}>
                <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                  {cghsResponse?.beneficiaryId
                    ? cghsResponse?.beneficiaryId?.length > 20
                      ? cghsResponse?.beneficiaryId?.substring(0, 20) + "..."
                      : cghsResponse?.beneficiaryId
                    : " "}
                </p>
              </Tooltip>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "24%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Token No.
              </p>
              <Tooltip title={cghsResponse?.tokenNumber}>
                <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                  {cghsResponse?.tokenNumber
                    ? cghsResponse?.tokenNumber?.length > 20
                      ? cghsResponse?.tokenNumber?.substring(0, 20) + "..."
                      : cghsResponse?.tokenNumber
                    : " "}
                </p>
              </Tooltip>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                borderRight: cghsResponse?.remark ? "1px solid #A6A6A6" : "",
                width: "24%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Time Issued
              </p>
              <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                {cghsResponse?.timeIssued || " "}
              </p>
            </div>

            {cghsResponse?.remark && (
              <div
                className="items"
                style={{
                  padding: "0px 20px",
                  // borderRightWidth: "1px",
                  // borderRightStyle: "solid",
                  // borderRightColor: "#A6A6A6",
                  width: "24%",
                }}
              >
                <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                  Overall Remarks
                </p>
                <Tooltip title={cghsResponse?.remark}></Tooltip>
                <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                  {cghsResponse?.remark
                    ? cghsResponse?.remark?.length > 20
                      ? cghsResponse?.remark?.substring(0, 20) + "..."
                      : cghsResponse?.remark
                    : " "}
                </p>
              </div>
            )}
          </div>

          {services &&
            services?.map((service: ComponentDetail) => (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  backgroundColor: "#EFF6FF",
                  border: "0.4px solid #A6A6A6",
                  borderRadius: "10px",
                  padding: "14px 20px 14px 20px",
                  marginTop: "0.5rem",
                  boxShadow: "0px -1px 4px 0px #00000040 inset",
                }}
              >
                <div
                  className="items"
                  style={{
                    // padding: "10px 20px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "24%",
                  }}
                >
                  <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                    Referral Type
                  </p>
                  <Tooltip title={service?.referralType}>
                    <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                      {service?.referralType
                        ? service?.referralType?.length > 20
                          ? service?.referralType?.substring(0, 20) + "..."
                          : service?.referralType
                        : " "}
                    </p>
                  </Tooltip>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0px 20px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "24%",
                  }}
                >
                  <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                    Component Detail
                  </p>
                  {/* <p style={{ fontWeight: "600",minHeight: "1.4rem", }}>{service?.name || " "}</p> */}
                  <Tooltip title={service?.name}>
                    <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                      {service?.name?.length > 20
                        ? service?.name?.substring(0, 20) + "..."
                        : service?.name || " "}
                    </p>
                  </Tooltip>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0px 20px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "24%",
                  }}
                >
                  <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                    Remarks
                  </p>
                  <Tooltip title={service?.remarks}>
                    <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                      {service?.remarks
                        ? service?.remarks?.length > 20
                          ? service?.remarks?.substring(0, 20) + "..."
                          : service?.remarks
                        : " "}
                    </p>
                  </Tooltip>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0px 20px",
                    // borderRightWidth: "1px",
                    // borderRightStyle: "solid",
                    // borderRightColor: "#A6A6A6",
                    width: "24%",
                  }}
                >
                  <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                    Valid Upto
                  </p>
                  <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                    {service?.validUpto || " "}
                  </p>
                </div>
              </div>
            ))}
        </>
      );
    } else if (echsResponse) {
      return (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              backgroundColor: "#EFF6FF",
              border: "0.4px solid #A6A6A6",
              borderRadius: "10px",
              padding: "14px 20px 14px 20px",
              marginTop: "0.5rem",
              boxShadow: "0px -1px 4px 0px #00000040 inset",
            }}
          >
            <div
              className="items"
              style={{
                // padding: "10px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "10%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                PolyClinic
              </p>
              <Tooltip title={echsResponse?.polyClinic}>
                <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                  {echsResponse?.polyClinic
                    ? echsResponse?.polyClinic?.length > 8
                      ? echsResponse?.polyClinic?.substring(0, 8) + "..."
                      : echsResponse?.polyClinic
                    : " "}
                </p>
              </Tooltip>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "15%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Referral For
              </p>
              <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                <Tooltip title={echsResponse?.referralFor}>
                  {echsResponse?.referralFor &&
                  echsResponse?.referralFor?.length > 12
                    ? echsResponse?.referralFor?.substring(0, 12) + "..."
                    : echsResponse?.referralFor || " "}
                </Tooltip>
              </p>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "14%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Patient Type
              </p>
              <Tooltip title={echsResponse?.referralType}>
                <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                  {echsResponse?.referralType &&
                  echsResponse?.referralType?.length > 12
                    ? echsResponse?.referralType?.substring(0, 12) + "..."
                    : echsResponse?.referralType || " "}
                </p>
              </Tooltip>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "16%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Card Category
              </p>
              <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                {echsResponse?.cardCategory || " "}
              </p>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "13%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Service No.
              </p>
              <Tooltip title={echsResponse?.serviceNumber}>
                <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                  {echsResponse?.serviceNumber
                    ? echsResponse?.serviceNumber?.length > 10
                      ? echsResponse?.serviceNumber?.substring(0, 10) + "..."
                      : echsResponse?.serviceNumber
                    : " "}
                </p>
              </Tooltip>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "15%",
              }}
            >
              <p
                style={{
                  color: "#575757",
                  marginBottom: "0.4rem",
                }}
              >
                Is Ip Allowed?
              </p>
              <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                {echsResponse?.ipAllowed ? "YES" : "NO"}
              </p>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                // borderRightWidth: "1px",
                // borderRightStyle: "solid",
                // borderRightColor: "#A6A6A6",
                width: "10%",
              }}
            >
              <p
                style={{
                  color: "#575757",
                  marginBottom: "0.4rem",
                }}
              >
                Air & Sc
              </p>
              <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                {echsResponse?.ariAndSC ? "YES" : "NO"}
              </p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              backgroundColor: "#EFF6FF",
              border: "0.4px solid #A6A6A6",
              borderRadius: "10px",
              padding: "14px 20px 14px 20px",
              marginTop: "0.5rem",
              boxShadow: "0px -1px 4px 0px #00000040 inset",
            }}
          >
            <div
              className="items"
              style={{
                // padding: "10px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "32%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Clinical Notes
              </p>
              <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                <Tooltip title={echsResponse?.clinicalNotes}>
                  {echsResponse?.clinicalNotes &&
                  echsResponse?.clinicalNotes?.length > 35
                    ? echsResponse?.clinicalNotes?.substring(0, 35) + "..."
                    : echsResponse?.clinicalNotes || " "}
                </Tooltip>
              </p>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                borderRightWidth: "1px",
                borderRightStyle: "solid",
                borderRightColor: "#A6A6A6",
                width: "32%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Investigation
              </p>
              <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                <Tooltip title={echsResponse?.investigation}>
                  {echsResponse?.investigation &&
                  echsResponse?.investigation?.length > 35
                    ? echsResponse?.investigation?.substring(0, 35) + "..."
                    : echsResponse?.investigation || " "}
                </Tooltip>
              </p>
            </div>

            <div
              className="items"
              style={{
                padding: "0px 20px",
                // borderRightWidth: "1px",
                // borderRightStyle: "solid",
                // borderRightColor: "#A6A6A6",
                width: "33%",
              }}
            >
              <p style={{ color: "#575757", marginBottom: "0.4rem" }}>
                Consultation For
              </p>
              <p style={{ fontWeight: "600", minHeight: "1.4rem" }}>
                <Tooltip title={echsResponse?.consultationFor}>
                  {echsResponse?.consultationFor &&
                  echsResponse?.consultationFor?.length > 35
                    ? echsResponse?.consultationFor?.substring(0, 35) + "..."
                    : echsResponse?.consultationFor || " "}
                </Tooltip>
              </p>
            </div>
          </div>
        </>
      );
    }
    return null;
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0) {
      dispatch(
        getVisitStageStates({
          visitStageId:
            typeof activeKey === "string"
              ? parseInt(activeKey)
              : parseInt(activeKey?.[0]),
        }),
      );
    }
  }, [activeKey]);

  const blockingStageIndex = newSteps?.visitStages?.findIndex((stage: any) => {
    const stageName = stage?.visitStage?.toUpperCase();

    return (
      patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal &&
      (stageName === "PORTAL REGISTRATION" ||
        stageName === "CLAIMID GENERATION") &&
      stage?.state?.toUpperCase() === "MANUAL UNVERIFIED"
    );
  });

  const getItems = () => {
    return (
      newSteps?.visitStages
        // ?.filter((stage: any) =>
        //   patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
        //     "OP" &&
        //   patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        //     "ECHS"
        //     ? stage?.visitStage?.toUpperCase() !== "PREAUTH"
        //     : true,
        // )
        ?.filter((stage: any) => {
          const visitType =
            patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase();

          const scheme =
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase();

          const userRole = auth?.role?.role?.toUpperCase();

          const isOP_ECHS = visitType === "OP" && scheme === "ECHS";
          const isFO = userRole === "FO_STAFF";

          if (isOP_ECHS && stage?.visitStage?.toUpperCase() === "PREAUTH") {
            return false;
          }

          if (isFO && stage?.visitStage?.toUpperCase() === "RESUBMISSION") {
            return false;
          }

          return true;
        })
        ?.map((stage: any, index: number) => {
          const visitStageName = stage?.visitStage?.toUpperCase();
          const key = String(stage?.visitStageId);
          const canExpand =
            patients?.fetchBasicDetails?.patientResponse?.uhidNo === "-"
              ? false
              : blockingStageIndex !== -1 && index > blockingStageIndex
                ? false
                : (auth?.role?.role === "FO_STAFF" &&
                      (newSteps?.visitStages?.[index - 1]?.intimated === true ||
                        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                          "ECHS")) ||
                    //   && (patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                    //     "OP" ||
                    // patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName?.toUpperCase() ===
                    //   "DAYCARE" ||
                    // patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName?.toUpperCase() ===
                    //   "CHEMO")
                    auth?.role?.role === "ADMIN"
                  ? true
                  : index === 0
                    ? true
                    : stage?.completed ||
                      newSteps?.visitStages?.[index - 1]?.canNavigate === true;
          const colorCoding = stage?.colorCoding;

          const getContainerByTitle = () => {
            switch (visitStageName) {
              case "ClaimId Generation"?.toUpperCase():
                return (
                  <ReferralAcceptanceContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                );
              case "Portal registration"?.toUpperCase():
                return patients?.fetchBasicDetails?.casesResponse
                  ?.portalMetaDataNames?.[0] === "CGHS" ? (
                  <PortalRegistrationCghsContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "CGHS AB" ? (
                  <PortalRegistrationNewCghsContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "STAR HEALTH" ? (
                  <PortalRegistrationStarHealthContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "Ayushman Bharat" ? (
                  <PortalRegistrationAyushmanContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : (
                  <></>
                );
              case "PREAUTH":
                return patients?.fetchBasicDetails?.casesResponse
                  ?.portalMetaDataNames?.[0] === "IHX" ? (
                  <PreAuthIhxContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "CGHS" ? (
                  <PreAuthCghsContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "CGHS AB" ? (
                  <PreAuthCghsContainerNew
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "ECHS" ? (
                  <PreAuthEchsContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "STAR HEALTH" ? (
                  <PreAuthStarHealthContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "Ayushman Bharat" ? (
                  <PreAuthAyushmanContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]
                    ?.toUpperCase()
                    ?.replace("-", " ")
                    ?.includes("HEALTH INDIA") ? (
                  <PreAuthHealthIndiaContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]
                    ?.toUpperCase()
                    ?.replace("-", " ")
                    ?.includes("HERITAGE") ? (
                  <PreAuthHeritageContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]
                    ?.toUpperCase()
                    ?.includes("FHPL") ? (
                  <PreAuthFhplContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : (
                  <></>
                );

              case "Bill Audit"?.toUpperCase():
                return (
                  <BillAuditStageContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                );

              case "Resubmission"?.toUpperCase():
                return (
                  <ViewResubmissionContainerCghsNew
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                    handleResubmission={handleResubmission}
                  />
                );

              case "DISCHARGE":
                return patients?.fetchBasicDetails?.casesResponse
                  ?.portalMetaDataNames?.[0] === "IHX" ? (
                  <DischargeIhxContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "CGHS" ? (
                  <DischargeCghsContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "CGHS AB" ? (
                  <DischargeCghsNewContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "ECHS" ? (
                  <DischargeEchsContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "STAR HEALTH" ? (
                  <DischargeStarHealthContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : (
                  <></>
                );
              case "CLAIM":
                return patients?.fetchBasicDetails?.casesResponse
                  ?.portalMetaDataNames?.[0] === "IHX" ? (
                  <ClaimIhxContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "CGHS" ? (
                  <ClaimCghsContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "CGHS AB" ? (
                  <ClaimCghsNewContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "ECHS" ? (
                  <ClaimEchsContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "STAR HEALTH" ? (
                  <ClaimStarHealthContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : patients?.fetchBasicDetails?.casesResponse
                    ?.portalMetaDataNames?.[0] === "Ayushman Bharat" ? (
                  <ClaimAyushmanContainer
                    activeKey={activeKey}
                    sseData={sseData}
                    sseUpdateCount={sseUpdateCount}
                  />
                ) : (
                  <></>
                );
              case "SETTLED":
                return <SettlementContainer activeKey={activeKey} />;
              default:
                return null;
            }
          };

          return {
            key,
            label: (
              <div
                style={{
                  ...styles.borderDesign,
                  backgroundColor: canExpand
                    ? colorCoding?.bgHexCode || "rgb(0, 76, 143)"
                    : colorCoding?.bgHexCode || "#d3e7f9",
                  pointerEvents: canExpand ? "auto" : "none",
                  opacity: canExpand ? 1 : 0.5,
                  borderRadius: canExpand
                    ? activeKey == key
                      ? "16px 16px 0 0"
                      : "16px"
                    : "16px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <CaretRightOutlined
                    rotate={activeKey == key ? 90 : 0}
                    style={{
                      color: canExpand
                        ? colorCoding?.textHexCode || "#fff"
                        : colorCoding?.textHexCode || "black",
                    }}
                  />
                  <span
                    style={{
                      fontSize: "20px",
                      color: canExpand
                        ? colorCoding?.textHexCode || "#fff"
                        : colorCoding?.textHexCode || "black",
                    }}
                  >
                    {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                      "OP" &&
                    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                      "ECHS" &&
                    stage?.visitStage?.toUpperCase() === "PREAUTH"
                      ? stage?.alternateName?.toUpperCase()
                      : visitStageName}
                  </span>
                </div>
                <div
                  style={styles.statusDesign}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveKey(key);
                  }}
                >
                  {activeKey == key ? (
                    stage?.visitStageId &&
                    selectedPatient?.visitInfoResponse?.id && (
                      <ManualStatus
                        stateData={stageAllState?.[stage?.visitStageId] || null}
                        status={stage?.stateId}
                        visitId={selectedPatient?.visitInfoResponse?.id}
                        visitStageId={stage?.visitStageId}
                        isUpdateable={true}
                        isCompleted={stage?.completed}
                      />
                    )
                  ) : (
                    <div
                      className="status-box"
                      style={{ background: "#F2F6F9", color: "black" }}
                    >
                      <div className="status-content">
                        <span
                          style={{
                            fontWeight: 400,
                            color: "#575757",
                            fontSize: "14px",
                          }}
                          className="status-label"
                        >
                          Status:
                        </span>
                        <span
                          style={{
                            fontWeight: 600,
                            color: "black",
                            fontSize: "14px",
                          }}
                          className="claim-id-value"
                        >
                          {stage?.state || "-"}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ),
            children: canExpand ? (
              <div style={styles.mainContent}>
                {/* {selectedPatient?.casesResponse?.schemeType === "TPA"
              ? getContainerByTitle()
              : null} */}
                {getContainerByTitle()}
              </div>
            ) : null,
          };
        })
    );
  };

  const handleEditSchemeDetails = () => {
    setIsEditSchemeDetail(!isEditSchemeDetail);
  };

  //Query Uploaded Documents

  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);

  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);

  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });

  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [previewDocumentOtNotes, setPreviewDocumentOtNotes] = useState(false);

  const updateOrAddDocument = (
    uploadedDocumentUrl: any,
    documentRes: IDocumentFields,
  ) => {
    const updatedDocuments = [...uploadedDocumentUrl];

    updatedDocuments.push({
      documentType: documentRes?.documentType,
      documentName: documentRes?.documentName,
      documentUrl: documentRes?.documentUrl,
      documentLabelType: documentRes?.documentLabelType,
      id: documentRes?.id,
      deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
    });

    // Return the updated array (ensures it's a flat array)
    return updatedDocuments;
  };

  const handleUpload = async () => {
    const CollectPostData = new FormData();
    if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
      CollectPostData.append(
        "hospitalId",
        patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString(),
      );
    }
    if (patients?.fetchBasicDetails?.patientResponse?.id) {
      CollectPostData.append(
        "patientId",
        patients?.fetchBasicDetails?.patientResponse?.id?.toString(),
      );
    }
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      CollectPostData.append(
        "caseId",
        patients?.fetchBasicDetails?.casesResponse?.id?.toString(),
      );
    }
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      CollectPostData.append(
        "visitId",
        patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString(),
      );
    }
    CollectPostData.append("documentType", previewFile.documentType);

    if (selectedFile?.file) {
      CollectPostData.append("file", selectedFile?.file);
    }

    try {
      const documentRes = await dispatch(
        UploadDocument({
          formData: CollectPostData,
          accessToken: auth.accessToken || "",
        }),
      ).unwrap();

      if (documentRes?.[0]?.documentLabelType === "OT NOTES") {
        handleSaveData(documentRes);
      }

      // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
      const updatedDocuments = [...documentUrls, ...documentRes];

      setDocumentUrls(updatedDocuments);
      setPreviewModalVisible(false);
      message.success(
        `${documentRes?.[0]?.documentLabelType} uploaded successfully`,
      );
    } catch (error) {
      console.error("Failed to upload document:", error);
    }
  };

  const handleSaveData = async (documentUrl: any) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
      caseBillAuditAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
      caseBillAuditAttachments: [],
    };

    payloadSchema["caseBillAuditAttachments"] = documentUrl;

    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const schemeMetaDataId =
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema,
        );
        message.success(`documents uploaded successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleFileChange = (documentType: string) => (e: any) => {
    const maxSize = 15 * 1024 * 1024;

    if (Array.isArray(e)) {
      return e;
    }
    if (e?.file) {
      setSelectedFile({ file: e.file, documentType: documentType });
      setPreviewFile({
        url: URL.createObjectURL(e.file),
        name: e.file.name,
        showUpload: true,
        documentType: documentType,
      });
      setPreviewModalVisible(true);
    }
    return e?.target?.files;
  };

  const handleOpen = (docType: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
  };

  const handleOpenOtNotes = (docType: any) => {
    setPreviewDocumentOtNotes(true);
    setClickedActiveTab(docType);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
  };

  const [isReplying, setIsReplying] = useState<boolean>(false);
  const [responseRemark, setResponseRemark] = useState<string>("");

  const areAllDocumentsUploaded = (
    documentUrls: {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[],
    documentRequest: any,
  ) => {
    const uploadedLabels = new Set(
      documentUrls?.map((doc) => doc.documentLabelType),
    );

    return documentRequest.every((requestedDoc: any) =>
      uploadedLabels.has(requestedDoc.name),
    );
  };

  const handleSubmit = () => {
    try {
      if (
        !areAllDocumentsUploaded(
          documentUrls,
          replyQuery?.queryRequiredDocuments,
        )
      ) {
        errorMessage("Please upload all required documents before submitting.");
        setIsReplying(false);
        return;
      }

      if (!responseRemark && replyQuery?.typeOfQuery === "Payer") {
        errorMessage("Please fill remark before submitting.");
        setIsReplying(false);
        return;
      }

      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const portalMetaDataId =
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];
      const casePreAuthQueryId = replyQuery?.id;
      if (caseId && visitId && casePreAuthQueryId) {
        const replyData: IPreAuthQueryReply = {
          returnedResponse: responseRemark,
          returnedDocumentUrl: documentUrls,
        };
        setIsReplying(true);
        dispatch(
          replyResponseToQuery({
            caseId,
            visitId,
            portalMetaDataId,
            replyData,
            casePreAuthQueryId,
          }),
        )
          .then(() => {
            setResponseRemark("");
            setDocumentUrls([]);
            message.success("Response Submitted");
            setReplyQueryModal(false);
            setIsReplying(false);
            dispatch(
              fetchQueries({
                caseId,
                visitId,
                portalMetaDataId,
                stageId: [replyQuery?.stageId],
              }),
            );
            setReplyQuery(null);
            handleFetchStepper();
            getTimelineDetail();
          })
          .catch((error) => {
            message.error("Failed to Submit Query");
            setIsReplying(false);
            console.error(error);
          });
      }
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setIsReplying(false);
    }
  };

  const handleGetData = () => {
    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const portalMetaDataId =
      patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];
    if (caseId && visitId) {
      dispatch(
        fetchQueries({
          caseId,
          visitId,
          portalMetaDataId,
          stageId: [replyQuery?.stageId],
        }),
      );
    }
  };

  const handleSubmitDocumentDeficiencyQuery = () => {
    try {
      const isDocumentUploaded = () => {
        const uploadedLabels = new Set(
          documentUrls?.map((doc) => doc.documentLabelType),
        );

        return uploadedLabels?.has(replyQuery?.oldDocument?.documentLabelType);
      };

      if (!isDocumentUploaded()) {
        errorMessage("Please upload required document before submitting.");
        setIsReplying(false);
        return;
      }

      if (!responseRemark && replyQuery?.typeOfQuery === "Payer") {
        errorMessage("Please fill remark before submitting.");
        setIsReplying(false);
        return;
      }

      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const portalMetaDataId =
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];
      const casePreAuthQueryId = replyQuery?.id;
      if (caseId && visitId && casePreAuthQueryId) {
        const replyData: IPreAuthQueryReply = {
          returnedResponse: responseRemark,
          returnedDocumentUrl: documentUrls,
          oldDocumentId: replyQuery?.oldDocumentId,
        };
        setIsReplying(true);
        dispatch(
          replyResponseToQuery({
            caseId,
            visitId,
            portalMetaDataId,
            replyData,
            casePreAuthQueryId,
          }),
        )
          .then(() => {
            setResponseRemark("");
            setDocumentUrls([]);
            message.success("Response Submitted");
            setReplyDeficiencyQueryModal(false);
            setIsReplying(false);
            dispatch(
              fetchQueries({
                caseId,
                visitId,
                portalMetaDataId,
                stageId: [replyQuery?.stageId],
              }),
            );
            setReplyQuery(null);
            handleFetchStepper();
            getTimelineDetail();
          })
          .catch((error) => {
            message.error("Failed to Submit Query");
            setIsReplying(false);
            console.error(error);
          });
      }
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setIsReplying(false);
    }
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number,
  ) => {
    const combinedUrls: any = [...documentUrls];
    const deleteDocument = combinedUrls?.find(
      (doc: any, index: any) => doc?.documentUrl === documentUrl,
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    const newUpdatedDocumentList = documentUrls?.filter(
      (doc: any, index: any) => doc?.documentUrl !== documentUrl,
    );
    setDocumentUrls(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (err) {
        console.error(err);
        message.error("Please, Try again later");
      }
      // fetchDocuments();
    }
  };

  const handleDeleteListOtNotes = async (
    documentType: string,
    documentUrl: string,
    i: number,
  ) => {
    const combinedUrls: any = otNotes?.documentList || [];
    const deleteDocument = combinedUrls?.find(
      (doc: any, index: any) => doc?.documentUrl === documentUrl,
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (err) {
        console.error(err);
        message.error("Please, Try again later");
      }
      fetchDocuments();

      setPreviewDocumentOtNotes(false);
    }
  };

  const [otNotes, setOtNotes] = useState<any>(null);

  const fetchDocuments = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId &&
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      try {
        const AllDocumentList = await getAllStarhealthDocumentsData(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        );
        setOtNotes(
          AllDocumentList?.["Bill Audit"]?.find((docType: any) =>
            docType?.label?.toLowerCase()?.includes("ot notes"),
          ),
        );
      } catch (err) {
        errorMessage("Please, Try again after sometime");
      }
    }
  };

  const [viewUploadedDocument, setViewUploadedDocument] =
    useState<boolean>(false);

  const [deficiencyFailedDocument, setDeficiencyFailedDocument] =
    useState<boolean>(false);

  const [viewDeficiencyFailedDocument, setViewDeficiencyFailedDocument] =
    useState<any>();

  const handleOpenUploadedDocument = (docType: any) => {
    setViewUploadedDocument(true);
    setClickedActiveTab(docType);
  };

  const handleViewDeficiencyFailedDocument = (query: any) => {
    setDeficiencyFailedDocument(true);
    setViewDeficiencyFailedDocument(query);
  };

  useEffect(() => {
    setDocumentUrls([]);
    setResponseRemark("");
  }, [replyQueryModal, replyDeficiencyQueryModal]);

  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          margin: "0 33%",
          textAlign: "center",
          padding: "3px 36px",
          // background: "#FED7AA",
          background: sseData
            ? statusColors[getStatusKey(sseData)]
            : statusColors[statusKey],
          color:
            (sseData
              ? statusColors[getStatusKey(sseData)]
              : statusColors[statusKey]) === "#FFA500"
              ? "black"
              : "white",
          borderRadius: "4px",
          // color: "black",
          fontWeight: "bold",
          marginTop: "0",
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          width: "449px",
          boxShadow: "0px -1px 12.2px 0px #00000040 inset",
          minHeight: "1.6rem",
          position: "absolute",
          top: "-23.5px",
          zIndex: 1,
        }}
      >
        {/* {selectedPatient?.visitInfoResponse?.visitStageName ? (
          <>
            🔔 {selectedPatient.visitInfoResponse.visitStageName}{" "}
            {selectedPatient.visitInfoResponse.stateName || ""}
          </>
        ) : (
          ""
        )} */}
        {sseData ? (
          <>🔔 {sseData?.split("~")?.[0]}</>
        ) : newSteps?.currentVisitStage?.visitStage ? (
          <>
            🔔{" "}
            {
              // patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
              //   "OP" &&
              // patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              //   "ECHS"
              // && newSteps?.currentVisitStage?.visitStage?.toUpperCase() === "PREAUTH"
              //   ? newSteps?.currentVisitStage?.alternateName?.toUpperCase() :
              newSteps?.currentVisitStage?.visitStage
            }{" "}
            {newSteps?.currentVisitStage?.state || ""}
          </>
        ) : selectedPatient?.visitInfoResponse?.visitStageName ? (
          <>
            🔔 {selectedPatient.visitInfoResponse.visitStageName}{" "}
            {selectedPatient.visitInfoResponse.stateName || ""}
          </>
        ) : (
          ""
        )}
      </div>
      <Card
        className="custom-patient-body-card-name"
        // style={{
        //   border: "0.4px solid #A6A6A6",
        //   borderRadius: "20px",
        //   // boxShadow: "0.5px 0.5px #00000040",
        //   boxShadow: "0px -1px 4px 0px #00000040 inset",
        // }}
        bordered={false}
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <Form
            form={form}
            onFinish={onFinish}
            initialValues={initialValues}
            layout="vertical"
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* <h4 style={{ color: "#A6A6A6", fontWeight: "600" }}>
                View Patient
              </h4> */}
              <Button
                style={{
                  border: "0.4px solid #004C8F",
                  color: "#004C8F",
                  boxShadow: "none",
                  fontWeight: "bolder",
                  padding: "6px 10px",
                  borderRadius: "16px",
                  fontSize: "1rem",
                  marginBottom: "8px",
                  // fontSize: "1rem",
                }}
                onClick={(e) => {
                  e.stopPropagation();

                  navigate({
                    pathname: ROUTES.PATIENT_LIST,
                  });
                }}
              >
                <DoubleLeftOutlined /> PATIENT LIST
              </Button>

              <Space>
                {!isManualSubmission && (
                  <Tag
                    style={{
                      backgroundColor: `${getPortalLabel(portalCurrentStatus).color}22`,
                      color: getPortalLabel(portalCurrentStatus).color,
                      borderRadius: "24px",
                      padding: "4px 10px",
                      flex: "1 1 20%",
                      fontWeight: "700",
                      fontSize: "0.8rem",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "6px",
                      cursor: "default",
                      boxShadow: " 0px -3px 4px 0px #00000040 inset",
                    }}
                  >
                    <span
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor:
                          getPortalLabel(portalCurrentStatus).color,
                        display: "inline-block",
                      }}
                    />
                    {getPortalLabel(portalCurrentStatus).text}
                  </Tag>
                )}

                <Button
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    fontWeight: "600",
                    flex: "1 1 20%",
                    borderRadius: "24px",
                    cursor: "pointer",
                    fontSize: "0.8rem",
                    boxShadow: " 0px -3px 4px 0px #00000040 inset",
                  }}
                  block
                  onClick={handleActivateDeactivate}
                >
                  {selectedPatient?.visitInfoResponse?.status
                    ? "DEACTIVATE"
                    : "ACTIVATE"}
                </Button>
                {/* <Button
                  style={{
                    backgroundColor: "#1FAF38",
                    color: "white",
                    fontWeight: "600",
                    flex: "1 1 20%",
                    borderRadius: "24px",
                    cursor: "pointer",
                    fontSize: "0.8rem",
                    boxShadow: " 0px -3px 4px 0px #00000040 inset",
                  }}
                  block
                  // onClick={handleEditPatient}
                >
                  Scheme Details
                </Button> */}
                {/* {auth?.role?.role !== "FO_STAFF" &&
                  auth?.role?.role !== "BO_STAFF" && (
                    <Button
                      style={{
                        backgroundColor: "#008B8B",
                        color: "white",
                        fontWeight: "600",
                        flex: "1 1 20%",
                        borderRadius: "24px",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        boxShadow: " 0px -3px 4px 0px #00000040 inset",
                      }}
                      block
                      // onClick={handleEditPatient}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNavigate(
                          `${ROUTES.PATIENT_CASE_DETAILS}/${selectedPatient?.casesResponse?.id}/${selectedPatient?.patientResponse?.id}`
                        );
                      }}
                    >
                      Visit History
                    </Button>
                  )} */}
                {isEdit ? (
                  <Button
                    type="primary"
                    icon={<CloseOutlined />}
                    onClick={handleEditPatient}
                    style={{ fontSize: "0.8rem" }}
                  >
                    CANCEL
                  </Button>
                ) : (
                  hasFunctionality("patientEdit") && (
                    <Button
                      style={{
                        backgroundColor: "#00549E",
                        color: "white",
                        fontWeight: "600",
                        flex: "1 1 20%",
                        borderRadius: "24px",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        boxShadow: " 0px -3px 4px 0px #00000040 inset",
                      }}
                      block
                      onClick={handleEditPatient}
                    >
                      Edit
                    </Button>
                  )
                )}
              </Space>
            </div>

            {isEdit ? (
              <Row gutter={[16, 4]}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item<FieldType>
                    label="PATIENT NAME"
                    name="fullName"
                    rules={[
                      { required: true, message: "Please input full name!" },
                      {
                        pattern: /^[A-Za-z\s./]+$/,
                        message:
                          "Name can only contain letters, spaces, and '/'.",
                      },
                    ]}
                  >
                    <Input
                      maxLength={50}
                      defaultValue={selectedPatient?.patientResponse?.fullName}
                      placeholder="ENTER PATIENT NAME"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item<FieldType>
                    label="PRN Number/UHID/OP no."
                    name="uhidNo"
                    rules={[
                      {
                        required: true,
                        message: "Please input PRN Number/UHID/OP no.!",
                      },
                    ]}
                  >
                    <Input
                      defaultValue={selectedPatient?.patientResponse?.uhidNo}
                      placeholder="ENTER PRN Number/UHID/OP no."
                      onChange={(e) => {
                        if (
                          patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                          "OP"
                        ) {
                          form.setFieldValue("opIpNumber", e.target.value);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={8}

                  // style={{ height: "83px" }}
                >
                  <Form.Item<FieldType> label="DOB" name="dob">
                    <DatePicker
                      format="DD-MMM-YYYY"
                      onChange={(date) => {
                        if (date) {
                          const age = calculateAge(date);
                          setAge(age);
                        } else {
                          setAge(null);
                          form.setFieldsValue({ dob: null, age: null });
                        }
                      }}
                      disabledDate={(current) => {
                        const oneYearAgo = dayjs()
                          .subtract(1, "year")
                          .startOf("day");
                        const hundredYearsAgo = dayjs()
                          .subtract(100, "year")
                          .startOf("day");
                        return (
                          (current && current > oneYearAgo) ||
                          current < hundredYearsAgo
                        );
                      }}
                      style={{ width: "100%" }}
                      allowClear
                      inputReadOnly={false}
                      placeholder="DD-MMM-YYYY"
                    />
                  </Form.Item>
                </Col>
                {auth?.role?.role !== "FO_STAFF" && (
                  <Col
                    xs={24}
                    sm={24}
                    md={8}

                    // style={{ height: "83px" }}
                  >
                    <Form.Item<FieldType> label="DOA" name="doa">
                      <DatePicker
                        format="DD-MMM-YYYY"
                        style={{ width: "100%" }}
                        allowClear
                        inputReadOnly={false}
                        placeholder="DD-MMM-YYYY"
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col
                  xs={24}
                  sm={24}
                  md={8}

                  // style={{ height: "83px" }}
                >
                  <Form.Item<FieldType>
                    label="AGE"
                    name="age"
                    rules={[
                      { required: true, message: "Please input age!" },
                      {
                        pattern: /^[0-9]+$/,
                        message: "Only numeric values are allowed!",
                      },
                      {
                        validator: (_, value) =>
                          value && parseInt(value, 10) > 120
                            ? Promise.reject("Please enter a valid age!")
                            : Promise.resolve(),
                      },
                    ]}
                  >
                    <Input placeholder="ENTER YOUR AGE" />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={8}

                  // style={{ height: "83px" }}
                >
                  <Form.Item<FieldType>
                    label="GENDER"
                    name="sex"
                    rules={[
                      { required: true, message: "Please input gender!" },
                    ]}
                  >
                    <Radio.Group name="sex">
                      <Radio value="Male">MALE</Radio>
                      <Radio value="Female">FEMALE</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={8}

                  // style={{ height: "83px" }}
                >
                  <Form.Item<FieldType>
                    label="PRIMARY MOBILE"
                    name="primaryMobile"
                    rules={[
                      { required: true, message: "Please input number!" },
                      {
                        pattern: /^[6-9]/,
                        message: "Number must start with 6, 7, 8, or 9!",
                      },
                      {
                        pattern: /^\d{10}$/,
                        message: "Number must be 10 digits!",
                      },
                    ]}
                  >
                    <Input
                      addonBefore={prefixSelector}
                      placeholder="ENTER YOUR PRIMARY NUMBER"
                      maxLength={10}
                    />
                  </Form.Item>
                </Col>
                {/* <Col
                  xs={24}
                  sm={24}
                  md={8}

                  // style={{ height: "83px" }}
                >
                  <Form.Item<FieldType>
                    label="SECONDARY MOBILE"
                    name="secondaryMobile"
                    rules={[
                      {
                        pattern: /^[6-9]/,
                        message: "Number must start with 6, 7, 8, or 9!",
                      },
                      {
                        pattern: /^\d{10}$/,
                        message: "Number must be 10 digits!",
                      },
                    ]}
                  >
                    <Input
                      addonBefore={secondaryPrefixSelector}
                      placeholder="ENTER YOUR SECONDARY NUMBER"
                      maxLength={10}
                    />
                  </Form.Item>
                </Col> */}
                <Col
                  xs={24}
                  sm={24}
                  md={8}

                  // style={{ height: "83px" }}
                >
                  <Form.Item<FieldType>
                    label="EMAIL"
                    name="email"
                    rules={[
                      {
                        type: "email",
                        message: "The input is not a valid email!",
                      },
                    ]}
                  >
                    <Input placeholder="ENTER YOUR EMAIL" maxLength={250} />
                  </Form.Item>
                </Col>

                {selectedPatient?.patientResponse?.cardCategory ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item<FieldType>
                      label="CARD CATEGORY"
                      name="cardCategory"
                      rules={[
                        {
                          required: true,
                          message: "Please select card category!",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Select a card category"
                        options={
                          cardCategoryList
                            ? cardCategoryList?.map((cardCategory) => ({
                                value: cardCategory,
                                label: cardCategory,
                              }))
                            : []
                        }
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  <></>
                )}

                {/* <Col
                  xs={24}
                  sm={24}
                  md={6}

                  // style={{ height: "83px" }}
                >
                  <Form.Item<FieldType>
                    label="COMMUNICATION CONSENT"
                    name="communicationConsent"
                    rules={[
                      {
                        required: true,
                        message: "Please input communication consent!",
                      },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value={true}>YES</Radio>
                      <Radio value={false}>NO</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item<FieldType>
                    label="PRIMARY POLICY HOLDER"
                    name="isPrimaryPolicyHolder"
                    rules={[
                      {
                        required: true,
                        message: "Please input secondary number!",
                      },
                    ]}
                  >
                    <Radio.Group
                      name="isPrimaryPolicyHolder"
                      value={initialValues.isPrimaryPolicyHolder}
                    >
                      <Radio value={true}>YES</Radio>
                      <Radio value={false}>NO</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col> */}

                <Col xs={24} sm={24} md={8}>
                  <Form.Item<FieldType>
                    label={
                      patients?.fetchBasicDetails?.visitInfoResponse
                        ?.visitType === "OP"
                        ? "OP Number"
                        : "IP Number"
                    }
                    name="opIpNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please input IP/OP Number!",
                      },
                      // {
                      //   pattern: /^[a-zA-Z0-9]+$/,
                      //   message: "Only alphanumeric characters are allowed!",
                      // },
                      {
                        pattern: /^\S.*\S$|^\S$/,
                        message:
                          "All characters are allowed (no leading/trailing spaces)!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter input IP/OP Number" />
                  </Form.Item>
                </Col>

                {patients?.fetchBasicDetails?.patientResponse?.uhidNo ===
                "-" ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item<FieldType>
                      label={
                        form
                          .getFieldValue("caseTypes")
                          ?.toUpperCase()
                          ?.includes("OP")
                          ? "DOV"
                          : "DOA"
                      }
                      name="doa"
                      rules={[
                        {
                          required: true,
                          message: "Please input dov/doa!",
                        },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format={dateFormat}
                        showTime
                        onChange={(date) => {
                          if (
                            date &&
                            labelNameForVisit == "IP Number" &&
                            !patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName
                              ?.toUpperCase()
                              ?.includes("CHEMO") &&
                            !patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName
                              ?.toUpperCase()
                              ?.includes("CATARACT") &&
                            !patients?.fetchBasicDetails?.casesResponse?.caseTypeMetaDataName
                              ?.toUpperCase()
                              ?.includes("DAYCARE")
                          ) {
                            const suggestedDod = date.clone().add(5, "days");
                            form.setFieldsValue({ dod: suggestedDod });
                          } else if (date && labelNameForVisit == "OP Number") {
                            const suggestedDod = date.clone();
                            form.setFieldsValue({ dod: suggestedDod });
                          } else {
                            const suggestedDod = date.clone();
                            form.setFieldsValue({ dod: suggestedDod });
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  <></>
                )}

                {/* {patients?.fetchBasicDetails?.patientResponse?.uhidNo ===
                "-" ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item<FieldType>
                      label="DEPARTMENT"
                      name="department"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input your department!",
                      //   },
                      // ]}
                    >
                      <Select
                        mode="multiple"
                        // onSearch={handleSearch}
                        showSearch
                        placeholder="Select a Department"
                        options={departmentListOptions}
                        style={{ width: "100%" }}
                        allowClear
                        // disabled={props?.isDisabled}
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  <></>
                )} */}

                {/* {patients?.fetchBasicDetails?.patientResponse?.uhidNo ===
                "-" ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item<FieldType>
                      label="DOCTOR"
                      name="doctorDetails"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input doctor name!",
                      //   },
                      // ]}
                    >
                      <Input
                        onChange={handleChange}
                        value={doctorName}
                        autoComplete="off"
                        placeholder="Enter Doctor name"
                      />
                      <div
                        id="scrollableDiv"
                        style={{
                          maxHeight: showDropDown ? "200px" : "auto",
                          overflow: "auto",
                          padding: "0 16px",
                          border: showDropDown
                            ? "1px solid rgba(140, 140, 140, 0.35)"
                            : "none",
                          backgroundColor: " #rgb(240 240 240)",
                          borderRadius: "8px",
                          cursor: "pointer",
                        }}
                      >
                        {doctorName ? (
                          showDropDown && availableDoctor?.length > 0 ? (
                            <List
                              dataSource={availableDoctor}
                              renderItem={(doctor, index) => (
                                <List.Item
                                  key={index}
                                  onClick={() => handleSelectDoctor(doctor)}
                                >
                                  <List.Item.Meta
                                    title={doctor?.firstName}
                                    description={doctor?.phone}
                                  />
                                </List.Item>
                              )}
                            />
                          ) : (
                            ""
                          )
                        ) : (
                          <></>
                        )}
                      </div>
                    </Form.Item>
                  </Col>
                ) : (
                  <></>
                )} */}
              </Row>
            ) : (
              <div
                className="patient-details-screen"
                style={{
                  display: "flex",
                  position: "relative",
                  alignItems: "center",
                  gap: "10px",
                  // backgroundColor: "#EFF6FF",
                  border: "0.4px solid #A6A6A6",
                  borderRadius: "10px",
                  // padding: "2px 0",
                  flexWrap: "wrap",
                  marginTop: "0.6rem",
                  // boxShadow: "1px 1px #00000040",
                  boxShadow: "0px -1px 4px 0px #00000040 inset",
                }}
              >
                <div
                  className="items"
                  style={{
                    padding: "10px 20px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "12%",
                  }}
                >
                  <p
                    style={{
                      marginBottom: "0.2rem",
                      fontSize: "1rem",
                      fontWeight: "700",
                      color: "#004C8F",
                    }}
                  >
                    <Tooltip title={selectedPatient?.patientResponse?.fullName}>
                      {selectedPatient?.patientResponse?.fullName
                        ? selectedPatient?.patientResponse?.fullName?.length >
                          15
                          ? selectedPatient?.patientResponse?.fullName?.substring(
                              0,
                              15,
                            ) + "..."
                          : selectedPatient?.patientResponse?.fullName
                        : " "}
                    </Tooltip>
                    {/* {selectedPatient?.patientResponse?.fullName} */}
                  </p>
                  <div className="bottom-patient-fields">
                    <Tooltip title={selectedPatient?.patientResponse?.age}>
                      <p
                        style={{
                          fontWeight: "600",
                          fontSize: "0.9rem",
                          borderRight: "1px solid #A6A6A6",
                          paddingRight: "10px",
                        }}
                      >
                        {selectedPatient?.patientResponse?.age
                          ? selectedPatient?.patientResponse?.age
                          : " "}
                      </p>
                    </Tooltip>
                    <Tooltip title={selectedPatient?.patientResponse?.sex}>
                      <p
                        style={{
                          fontWeight: "600",
                          fontSize: "0.9rem",
                          borderRight: "1px solid #A6A6A6",
                          paddingRight: "10px",
                        }}
                      >
                        {selectedPatient?.patientResponse?.sex
                          ? selectedPatient?.patientResponse?.sex?.substring(
                              0,
                              1,
                            )
                          : " "}
                      </p>
                    </Tooltip>
                    <Tooltip title={selectedPatient?.patientResponse?.uhidNo}>
                      <p
                        style={{
                          fontWeight: "600",
                          fontSize: "0.9rem",
                          color: "#D51E1E",
                        }}
                      >
                        #
                        {selectedPatient?.patientResponse?.uhidNo
                          ? selectedPatient?.patientResponse?.uhidNo?.length > 7
                            ? selectedPatient?.patientResponse?.uhidNo?.substring(
                                0,
                                7,
                              ) + "..."
                            : selectedPatient?.patientResponse?.uhidNo
                          : " "}
                      </p>
                    </Tooltip>
                  </div>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0px 4px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "6%",
                  }}
                >
                  <p
                    style={{
                      color: "#575757",
                      fontSize: "0.8rem",
                      marginBottom: "0.2rem",
                    }}
                  >
                    Scheme
                  </p>
                  {/* <p
                                    style={{
                                      fontWeight: "600",
                                      minHeight: "1.4rem",
                                    }}
                                  > */}
                  <Tooltip
                    title={getSchemeDisplayName(selectedPatient?.casesResponse)}  //selectedPatient?.casesResponse?.schemeMetaDataName
                  >
                    <p
                      style={{
                        fontWeight: "600",
                        minHeight: "1.4rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      {getSchemeDisplayName(selectedPatient?.casesResponse) &&
                      getSchemeDisplayName(selectedPatient?.casesResponse)
                        ?.length > 10
                        ? getSchemeDisplayName(selectedPatient?.casesResponse)?.substring(
                            0,
                            10,
                          ) + "..."
                        : getSchemeDisplayName(selectedPatient?.casesResponse) ||
                          " "}
                    </p>
                  </Tooltip>
                  {/* {selectedPatient?.casesResponse
                                      ?.schemeMetaDataName || " "}
                                  </p> */}
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0 4px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "6.5%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                        color: "#575757",
                      }}
                    >
                      Hospital
                    </p>
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      <Tooltip
                        title={selectedPatient?.casesResponse?.healthCareName}
                      >
                        <p
                          style={{
                            fontWeight: "600",
                            minHeight: "1.4rem",
                            fontSize: "0.8rem",
                          }}
                        >
                          {selectedPatient?.casesResponse?.healthCareName &&
                          selectedPatient?.casesResponse?.healthCareName
                            ?.length > 12
                            ? selectedPatient?.casesResponse?.healthCareName?.substring(
                                0,
                                12,
                              ) + "..."
                            : selectedPatient?.casesResponse?.healthCareName ||
                              " "}
                        </p>
                      </Tooltip>
                    </p>
                  </div>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0 4px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "5.5%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                        color: "#575757",
                      }}
                    >
                      Case Type
                    </p>
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      <Tooltip
                        title={
                          selectedPatient?.casesResponse?.caseTypeMetaDataName
                        }
                      >
                        <p
                          style={{
                            fontWeight: "600",
                            minHeight: "1.4rem",
                          }}
                        >
                          {selectedPatient?.casesResponse
                            ?.caseTypeMetaDataName &&
                          selectedPatient?.casesResponse?.caseTypeMetaDataName
                            ?.length > 10
                            ? selectedPatient?.casesResponse?.caseTypeMetaDataName?.substring(
                                0,
                                10,
                              ) + "..."
                            : selectedPatient?.casesResponse
                                ?.caseTypeMetaDataName || " "}
                        </p>
                      </Tooltip>
                    </p>
                  </div>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0 4px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "7%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                        color: "#575757",
                      }}
                    >
                      Claim Id
                    </p>
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      <Tooltip title={displayClaimId?.toUpperCase()}>
                        <span
                          style={{
                            color: "darkcyan",
                            fontWeight: "bold",
                          }}
                        >
                          {displayClaimId &&
                          displayClaimId.toUpperCase().length > 12
                            ? `${displayClaimId
                                .toUpperCase()
                                .substring(0, 8)}..${displayClaimId
                                .toUpperCase()
                                .slice(-4)}`
                            : displayClaimId?.toUpperCase()}
                        </span>
                      </Tooltip>
                    </p>
                  </div>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0px 5px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "6%",
                  }}
                >
                  <Tooltip
                    title={
                      selectedPatient?.patientResponse
                        ?.patientSchemeNewResponseList?.[0]?.schemePolicyNumber
                    }
                  >
                    <p
                      style={{
                        color: "#575757",
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      Card Id
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        minHeight: "1.4rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      {selectedPatient?.patientResponse
                        ?.patientSchemeNewResponseList?.[0]?.schemePolicyNumber
                        ? selectedPatient?.patientResponse
                            ?.patientSchemeNewResponseList?.[0]
                            ?.schemePolicyNumber?.length > 8
                          ? selectedPatient?.patientResponse?.patientSchemeNewResponseList?.[0]?.schemePolicyNumber?.substring(
                              0,
                              8,
                            ) + "..."
                          : selectedPatient?.patientResponse
                              ?.patientSchemeNewResponseList?.[0]
                              ?.schemePolicyNumber
                        : " "}
                    </p>
                  </Tooltip>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0 4px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "6%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                        color: "#575757",
                      }}
                    >
                      CR No.
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {selectedPatient?.visitInfoResponse?.creditNumber || " "}
                    </p>
                  </div>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0px 5px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width:
                      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "ECHS" &&
                      patients?.fetchBasicDetails?.referralInfoResponse
                        ?.echsReferralResponse?.referralNo
                        ? "5%"
                        : "6%",
                  }}
                >
                  <Tooltip title={selectedPatient?.visitInfoResponse?.opNumber}>
                    <p
                      style={{
                        color: "#575757",
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      Ip/Op No.
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        minHeight: "1.4rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      {selectedPatient?.visitInfoResponse?.opNumber
                        ? selectedPatient?.visitInfoResponse?.opNumber?.toString()
                            ?.length > 10
                          ? selectedPatient?.visitInfoResponse?.opNumber
                              ?.toString()
                              ?.substring(0, 7) + "..."
                          : selectedPatient?.visitInfoResponse?.opNumber
                        : " "}
                    </p>
                  </Tooltip>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0px 5px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width:
                      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "ECHS" &&
                      patients?.fetchBasicDetails?.referralInfoResponse
                        ?.echsReferralResponse?.referralNo
                        ? "7%"
                        : "8.5%",
                  }}
                >
                  <p
                    style={{
                      color: "#575757",
                      marginBottom: "0.2rem",
                      fontSize: "0.8rem",
                    }}
                  >
                    DOA
                  </p>
                  <p
                    style={{
                      fontWeight: "600",
                      minHeight: "1.4rem",
                      fontSize: "0.8rem",
                    }}
                  >
                    {selectedPatient?.visitInfoResponse?.doa
                      ? formatDateForUIWithTime(
                          selectedPatient?.visitInfoResponse?.doa,
                        )
                      : " "}
                  </p>
                </div>

                {/* <div
                  className="items"
                  style={{
                    padding: "0px 4px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "5.5%",
                  }}
                >
                  <p
                    style={{
                      color: "#575757",
                      marginBottom: "0.2rem",
                      fontSize: "0.8rem",
                      fontWeight: "400",
                    }}
                  >
                    Department
                  </p>
                  <p
                    style={{
                      fontWeight: "600",
                      minHeight: "1.4rem",
                      fontSize: "0.8rem",
                    }}
                  >
                    <Tooltip
                      title={
                        Array.isArray(
                          selectedPatient?.visitInfoResponse?.department,
                        )
                          ? selectedPatient?.visitInfoResponse?.department.join(
                              ", ",
                            )
                          : " "
                      }
                    >
                      {Array.isArray(
                        selectedPatient?.visitInfoResponse?.department,
                      )
                        ? selectedPatient.visitInfoResponse.department.join(
                            ", ",
                          ).length > 10
                          ? selectedPatient.visitInfoResponse.department
                              .join(", ")
                              .substring(0, 10) + "..."
                          : selectedPatient.visitInfoResponse.department.join(
                              ", ",
                            )
                        : " "}
                    </Tooltip>
                  </p>
                </div> */}

                {patients?.fetchBasicDetails?.casesResponse?.schemeType?.toUpperCase() ===
                "GOVT" ? (
                  <div
                    className="items"
                    style={{
                      padding: "0px 5px",
                      borderRightWidth: "1px",
                      borderRightStyle: "solid",
                      borderRightColor: "#A6A6A6",
                      width: "6.5%",
                    }}
                  >
                    <Tooltip
                      title={selectedPatient?.patientResponse?.cardCategory}
                    >
                      <p
                        style={{
                          color: "#575757",
                          marginBottom: "0.2rem",
                          fontSize: "0.8rem",
                        }}
                      >
                        Card Category
                      </p>
                      <p
                        style={{
                          fontWeight: "600",
                          minHeight: "1.4rem",
                          fontSize: "0.8rem",
                        }}
                      >
                        {selectedPatient?.patientResponse?.cardCategory
                          ? selectedPatient?.patientResponse?.cardCategory?.toString()
                              ?.length > 10
                            ? selectedPatient?.patientResponse?.cardCategory
                                ?.toString()
                                ?.substring(0, 10) + "..."
                            : selectedPatient?.patientResponse?.cardCategory
                          : " "}
                      </p>
                    </Tooltip>
                  </div>
                ) : (
                  <></>
                )}

                {patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                  "ECHS" &&
                patients?.fetchBasicDetails?.referralInfoResponse
                  ?.echsReferralResponse?.referralNo ? (
                  <div
                    className="items"
                    style={{
                      padding: "0px 5px",
                      borderRightWidth: "1px",
                      borderRightStyle: "solid",
                      borderRightColor: "#A6A6A6",
                      width: "5%",
                    }}
                  >
                    <p
                      style={{
                        color: "#575757",
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      Ref. Visit No.
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        minHeight: "1.4rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      {selectedPatient?.visitInfoResponse?.sessionNumber
                        ? selectedPatient?.visitInfoResponse?.sessionNumber
                        : " "}
                    </p>
                  </div>
                ) : (
                  <></>
                )}

                {/* <div
                  className="items"
                  style={{
                    padding: "0px 5px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "6%",
                  }}
                >
                  <Tooltip
                    title={selectedPatient?.visitInfoResponse?.procedure}
                  >
                    <p
                      style={{
                        color: "#575757",
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      Procedure
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        minHeight: "1.4rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      {selectedPatient?.visitInfoResponse?.procedure
                        ? selectedPatient?.visitInfoResponse?.procedure?.toString()
                            ?.length > 10
                          ? selectedPatient?.visitInfoResponse?.procedure
                              ?.toString()
                              ?.substring(0, 10) + "..."
                          : selectedPatient?.visitInfoResponse?.procedure
                        : " "}
                    </p>
                  </Tooltip>
                </div> */}

                <div
                  className="items"
                  style={{
                    padding: "0px 5px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width:
                      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "ECHS" &&
                      patients?.fetchBasicDetails?.referralInfoResponse
                        ?.echsReferralResponse?.referralNo
                        ? "7%"
                        : "8.5%",
                  }}
                >
                  <p
                    style={{
                      color: "#575757",
                      marginBottom: "0.2rem",
                      fontSize: "0.8rem",
                    }}
                  >
                    Last Updated
                  </p>
                  <p
                    style={{
                      fontWeight: "600",
                      minHeight: "1.4rem",
                      fontSize: "0.8rem",
                    }}
                  >
                    {selectedPatient?.visitInfoResponse?.modifiedAt
                      ? formattedDateWithTimeUstToIst(
                          selectedPatient?.visitInfoResponse?.modifiedAt,
                        )
                      : " "}
                  </p>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0px 5px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width:
                      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "ECHS" &&
                      patients?.fetchBasicDetails?.referralInfoResponse
                        ?.echsReferralResponse?.referralNo
                        ? "5.5%"
                        : "6%",
                  }}
                >
                  <Tooltip
                    title={selectedPatient?.visitInfoResponse?.portalStatus}
                  >
                    <p
                      style={{
                        color: "#575757",
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      Portal Status
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        minHeight: "1.4rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      {selectedPatient?.visitInfoResponse?.portalStatus
                        ? selectedPatient?.visitInfoResponse?.portalStatus?.toString()
                            ?.length > 8
                          ? selectedPatient?.visitInfoResponse?.portalStatus
                              ?.toString()
                              ?.substring(0, 6) + "..."
                          : selectedPatient?.visitInfoResponse?.portalStatus
                        : " "}
                    </p>
                  </Tooltip>
                </div>

                <div
                  className="items"
                  style={{
                    padding: "0px 5px",
                    // borderRightWidth: "1px",
                    // borderRightStyle: "solid",
                    // borderRightColor: "#A6A6A6",
                    width: "7%",
                  }}
                >
                  <Tooltip
                    title={
                      selectedPatient?.visitInfoResponse?.assignedToUserName
                    }
                  >
                    <p
                      style={{
                        color: "#575757",
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      Assigned User
                    </p>
                    <p
                      style={{
                        fontWeight: "600",
                        minHeight: "1.4rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      {selectedPatient?.visitInfoResponse?.assignedToUserName
                        ? selectedPatient?.visitInfoResponse?.assignedToUserName?.toString()
                            ?.length > 12
                          ? selectedPatient?.visitInfoResponse?.assignedToUserName
                              ?.toString()
                              ?.substring(0, 12) + "..."
                          : selectedPatient?.visitInfoResponse
                              ?.assignedToUserName
                        : " "}
                    </p>
                  </Tooltip>
                </div>

                {/* <div
                  style={{
                    position: "absolute",
                    right: "3rem",
                    bottom: "-8px",
                    zIndex: "100000",
                    cursor: "pointer",
                  }}
                >
                  <p
                    style={{
                      color: "#D51E1E",
                      border: "1px solid #A6A6A6",
                      borderRadius: "16px",
                      padding: "2px 8px",
                      fontSize: "14px",
                      margin: 0,
                      background: "white",
                    }}
                  >
                    view more
                  </p>
                </div> */}

                {/* <div
                  className="items"
                  style={{
                    padding: "10px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "22%",
                  }}
                >
                  <div
                    className="patient-biometrics"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "40px",
                    }}
                  >
                    <div>
                      {" "}
                      <p
                        style={{
                          marginBottom: "0.2rem",
                          fontSize: "0.8rem",
                        }}
                      >
                        Date of Birth
                      </p>
                      <p
                        style={{
                          fontWeight: "700",
                          fontSize: "0.8rem",
                          minHeight: "1.4rem",
                        }}
                      >
                        {selectedPatient?.patientResponse?.dob
                          ? convertDateFormat(
                              selectedPatient?.patientResponse?.dob
                            )
                              ?.split("-")
                              ?.join(" ")
                          : ""}
                      </p>
                    </div>

                    <div>
                      {" "}
                      <p
                        style={{
                          marginBottom: "0.2rem",
                          fontSize: "0.8rem",
                        }}
                      >
                        Age
                      </p>
                      <p
                        style={{
                          fontWeight: "700",
                          fontSize: "0.8rem",
                          minHeight: "1.4rem",
                        }}
                      >
                        {selectedPatient?.patientResponse?.age || " "} Years
                      </p>
                    </div>
                    <div>
                      {" "}
                      <p
                        style={{
                          marginBottom: "0.2rem",
                          fontSize: "0.8rem",
                        }}
                      >
                        Gender
                      </p>
                      <p
                        style={{
                          fontWeight: "700",
                          fontSize: "0.8rem",
                          minHeight: "1.4rem",
                        }}
                      >
                        {selectedPatient?.patientResponse?.sex || " "}
                      </p>
                    </div>
                  </div>
                </div> */}

                {/* <div
                  className="items"
                  style={{
                    padding: "10px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "30%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                      }}
                    >
                      Primary Mobile
                    </p>
                    <p style={{ fontWeight: "700", fontSize: "0.8rem",minHeight: "1.4rem" }}>
                      {selectedPatient?.primaryMobile || " "}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        fontSize: "0.8rem",
                      }}
                    >
                      <WhatsAppOutlined
                        style={{ color: "#25D366", fontSize: "1.2rem" }}
                      />
                      <span style={{ fontWeight: "700" }}>
                        {selectedPatient?.primaryMobile || " "}
                      </span>
                      <Switch
                        style={{
                          backgroundColor: "#FF9F43",
                        }}
                        checkedChildren=""
                        unCheckedChildren=""
                        defaultChecked = {selectedPatient?.primaryMobileOnWhatsApp}
                      />
                    </div>
                  </div>

                  
                </div> */}

                {/* <div
                  className="items"
                  style={{
                    padding: "10px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "13%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.8rem",
                      fontSize: "0.8rem",
                      marginBottom: "0.2rem",
                    }}
                  >
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        width: "70%",
                      }}
                    >
                      Primary Mobile
                    </p>

                    <WhatsAppOutlined
                      style={{ color: "#25D366", fontSize: "1.2rem" }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // gap: "1.2rem",
                      fontSize: "0.8rem",
                      marginBottom: "0.6rem",
                    }}
                  >
                    <span style={{ fontWeight: "700", width: "70%" }}>
                      {selectedPatient?.patientResponse?.primaryMobile
                        ? selectedPatient?.patientResponse?.primaryMobile?.replace(
                            /(\d{3})(\d{3})(\d{4})/,
                            "$1-$2-$3"
                          )
                        : " "}
                    </span>
                    <Switch
                      style={{
                        transform: "scale(0.7)",
                        backgroundColor: selectedPatient?.patientResponse
                          ?.primaryMobileOnWhatsApp
                          ? "#00549E"
                          : "#D9D9D9",
                      }}
                      checkedChildren=""
                      unCheckedChildren=""
                      checked={
                        selectedPatient?.patientResponse
                          ?.primaryMobileOnWhatsApp
                      }
                    />
                  </div>
                </div> */}

                {/* <div
                  className="items"
                  style={{
                    padding: "10px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "12%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                      }}
                    >
                      Secondary Mobile
                    </p>
                    <p style={{ fontWeight: "700", fontSize: "0.8rem",minHeight: "1.4rem" }}>
                      {selectedPatient?.secondaryMobile || " "}
                    </p>
                  </div>
                </div> */}

                {/* <div
                  className="items"
                  style={{
                    padding: "10px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "14%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.8rem",
                      fontSize: "0.8rem",
                      marginBottom: "0.2rem",
                    }}
                  >
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        width: "70%",
                      }}
                    >
                      Secondary Mobile
                    </p>

                    <WhatsAppOutlined
                      style={{ color: "#25D366", fontSize: "1.2rem" }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // gap: "1.4rem",
                      fontSize: "0.8rem",
                      marginBottom: "0.6rem",
                    }}
                  >
                    <span style={{ fontWeight: "700", width: "70%" }}>
                      {selectedPatient?.patientResponse?.secondaryMobile
                        ? selectedPatient?.patientResponse?.secondaryMobile?.replace(
                            /(\d{3})(\d{3})(\d{4})/,
                            "$1-$2-$3"
                          )
                        : " "}
                    </span>
                    <Switch
                      style={{
                        transform: "scale(0.7)", // Reduces the size of the Switch
                        backgroundColor: selectedPatient?.patientResponse
                          ?.secondaryMobileOnWhatsApp
                          ? "#00549E"
                          : "#D9D9D9", // Ensures fallback color for clarity
                      }}
                      checkedChildren=""
                      unCheckedChildren=""
                      checked={
                        selectedPatient?.patientResponse
                          ?.secondaryMobileOnWhatsApp
                      }
                    />
                  </div>
                </div> */}

                {/* <div
                  className="items"
                  style={{
                    padding: "10px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "17%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                      }}
                    >
                      E-mail
                    </p>
                    <p
                      style={{
                        fontWeight: "700",
                        fontSize: "0.8rem",
                        minHeight: "1.4rem",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {selectedPatient?.patientResponse?.email || " "}
                    </p>
                  </div>
                </div> */}

                {/* <div
                  className="items"
                  style={{
                    padding: "10px",
                    // borderRightWidth: "1px",
                    // borderRightStyle: "solid",
                    // borderRightColor: "#A6A6A6",
                    width: "14%",
                  }}
                >
                  <div>
                    {" "}
                    <p
                      style={{
                        marginBottom: "0.2rem",
                        fontSize: "0.8rem",
                        fontWeight: "400",
                      }}
                    >
                      Communication Consent
                    </p>
                    <p style={{ fontWeight: "600", fontSize: "0.8rem", }}>
                        {selectedPatient?.communicationConsent ? "YES" : "NO"}
                      </p>
                    <Radio.Group
                      name="communicationConsent"
                      disabled
                      value={
                        selectedPatient?.patientResponse?.communicationConsent
                      }
                      style={{ marginBottom: "1rem" }}
                    >
                      <Radio
                        value={true}
                        style={{ fontSize: "0.8rem" }}
                        className="orange-radio"
                      >
                        YES
                      </Radio>
                      <Radio
                        value={false}
                        style={{ fontSize: "0.8rem" }}
                        className="orange-radio"
                      >
                        NO
                      </Radio>
                    </Radio.Group>
                  </div>
                </div> */}

                {/* <div
                  className="items"
                  style={{
                    padding: "10px",
                    borderRightWidth: "1px",
                    borderRightStyle: "solid",
                    borderRightColor: "#A6A6A6",
                    width: "auto",
                  }}
                >
                    <div>
                      {" "}
                      <p
                        style={{
                          marginBottom: "0.2rem",
                          fontSize: "0.8rem",
                        }}
                      >
                        Primary Policy Holder
                      </p>
                      <p style={{ fontWeight: "600", fontSize: "0.8rem", }}>
                      {selectedPatient?.isPrimaryPolicyHolder ? "YES" : "NO"}
                      </p>
                    </div>
                  
                  
                  
                </div> */}
              </div>
            )}

            {isEdit && (
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  UPDATE
                </Button>
              </Form.Item>
            )}
          </Form>
        </Space>
      </Card>

      <Row gutter={16} style={{ backgroundColor: "white" }}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Col span={24}>
            <Card
              className="custom-patient-card custom-patient-body-card"
              style={{
                position: "relative",
                marginTop: "0.8rem",
                backgroundColor: "#F9F9F9",
                border: "0.4px solid #A6A6A6",
                borderRadius: "20px",
                // boxShadow: "0.5px 0.5px #00000040",
                boxShadow: "0px -1px 4px 0px #00000040 inset",
                padding: "1rem 0",
              }}
            >
              {/* <div
                style={{
                  margin: "0 23%",
                  textAlign: "center",
                  padding: "3px 36px",
                  // background: "#FED7AA",
                  background: statusColors[statusKey],
                  color:
                    statusColors[statusKey] === "#FFA500" ? "black" : "white",
                  borderRadius: "4px",
                  // color: "black",
                  fontWeight: "bold",
                  marginTop: "0",
                  borderBottomLeftRadius: "20px",
                  borderBottomRightRadius: "20px",
                  width: "449px",
                  boxShadow: "0px -1px 12.2px 0px #00000040 inset",
                  minHeight: "1.6rem",
                }}
              >
                {selectedPatient?.visitInfoResponse?.visitStageName ? (
                  <>
                    🔔 {selectedPatient.visitInfoResponse.visitStageName}{" "}
                    {selectedPatient.visitInfoResponse.stateName || ""}
                  </>
                ) : (
                  ""
                )}
              </div> */}
              {/* <h4 style={{ color: "#A6A6A6", fontWeight: "600" }}>
                {" "}
              </h4> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3 style={{ color: "rgb(0, 84, 157)", marginBottom: 0 }}>
                  {patients?.fetchBasicDetails?.casesResponse
                    ?.integratedWithPortal
                    ? "Auto Submission"
                    : "Manual Submission"}
                </h3>
                <div
                  className="buttons"
                  style={{
                    // position: "absolute",
                    // right: "32px",
                    // top: "18px",
                    display: "flex",
                    gap: "10px",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    zIndex: 1,
                    width: "55%",
                    marginLeft: "auto",
                  }}
                >
                  <div style={{ minWidth: "40%", maxWidth: "100%" }}>
                    <ClaimIDManuallyId />
                  </div>
                  <div
                    style={{ width: "auto", minWidth: "38%", maxWidth: "100%" }}
                  >
                    {(selectedPatient?.visitInfoResponse?.portalStatus ||
                      true) && (
                      <ManualPortalStatus
                        status={
                          selectedPatient?.visitInfoResponse?.portalStatus ||
                          "-"
                        }
                        visitId={selectedPatient?.visitInfoResponse?.id}
                        // visitStageId={currentActiveStage?.visitStageId}
                        isUpdateable={
                          hasFunctionality("portalStatus") && !isGovt
                            ? true
                            : false
                        }
                      />
                    )}
                  </div>
                  {auth?.role?.role == "FO_STAFF" &&
                  selectedPatient?.visitInfoResponse?.visitStageName &&
                  selectedPatient?.visitInfoResponse?.message &&
                  selectedPatient?.visitInfoResponse?.visitStageName?.toUpperCase() !=
                    "PORTAL REGISTRATION" &&
                  selectedPatient?.visitInfoResponse?.message?.toUpperCase() !=
                    "PREAUTH PENDING" ? (
                    <></>
                  ) : (
                    // <Button
                    //   style={{
                    //     backgroundColor: "darkcyan",
                    //     color: "white",
                    //     fontWeight: "600",
                    //     flex: "1 1 20%",
                    //     borderRadius: "24px",
                    //     cursor: "pointer",
                    //     fontSize: "0.8rem",
                    //     boxShadow: " 0px -3px 4px 0px #00000040 inset",
                    //   }}
                    //   block
                    //   onClick={(e) => {
                    //     e.stopPropagation();
                    //     if (!flag) {
                    //       handleNavigate(
                    //         `${ROUTES.BASIC_DETAILS}/${selectedPatient?.visitInfoResponse?.id}`
                    //       );
                    //     } else {
                    //       handleFetchStepper();
                    //     }
                    //   }}
                    // >
                    //   {selectedPatient?.visitInfoResponse?.visitStageName
                    //     ? selectedPatient?.visitInfoResponse?.visitStageName
                    //     : "PREAUTH"}
                    // </Button>
                    selectedPatient?.visitInfoResponse?.visitStageName &&
                    auth?.role?.role !== "FO_STAFF" && (
                      // <Button
                      //   style={{
                      //     backgroundColor: "darkcyan",
                      //     color: "white",
                      //     fontWeight: "600",
                      //     flex: "1 1 20%",
                      //     borderRadius: "24px",
                      //     cursor: "pointer",
                      //     fontSize: "0.8rem",
                      //     boxShadow: " 0px -3px 4px 0px #00000040 inset",
                      //   }}
                      //   block
                      //   onClick={(e) => {
                      //     e.stopPropagation();
                      //     if (!flag) {
                      //       handleNavigate(
                      //         `${ROUTES.BASIC_DETAILS}/${selectedPatient?.visitInfoResponse?.id}`
                      //       );
                      //     } else {
                      //       handleFetchStepper();
                      //     }
                      //   }}
                      // >
                      //   {selectedPatient?.visitInfoResponse?.visitStageName
                      //     ? selectedPatient?.visitInfoResponse?.visitStageName
                      //     : "PREAUTH"}
                      // </Button>
                      <></>
                    )
                  )}

                  {/* <Button
                style={{
                  backgroundColor: "#808184",
                  color: "white",
                  fontWeight: "600",
                  flex: "1 1 20%",
                  borderRadius: "24px",
                  cursor: "pointer",
                  fontSize: "0.8rem",
                }}
                block
                onClick={(e) => {
                  e.stopPropagation();
                  // handleNavigate(
                  //   `${ROUTES.BASIC_DETAILS}/${selectedPatient?.visitInfoResponse?.id}`
                  // );
                }}
              >
                Billing
              </Button> */}

                  {/* <Button
                  style={{
                    backgroundColor: "darkcyan",
                    color: "white",
                    fontWeight: "600",
                    flex: "1 1 20%",
                    borderRadius: "24px",
                    cursor: "pointer",
                    fontSize: "0.8rem",
                    boxShadow: " 0px -3px 4px 0px #00000040 inset",
                  }}
                  block
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!flag) {
                      handleNavigate(
                        `${ROUTES.BASIC_DETAILS}/${selectedPatient?.visitInfoResponse?.id}`
                      );
                    } else {
                      handleFetchStepper();
                    }
                  }}
                >
                  {selectedPatient?.visitInfoResponse?.visitStageName
                    ? selectedPatient?.visitInfoResponse?.visitStageName
                    : "PREAUTH"}
                </Button> */}

                  {/* {selectedPatient?.visitInfoResponse?.visitType?.toUpperCase() ===
                  "OP" &&
                  hasFunctionality("opdBillList") && (
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#808184",
                        color: "white",
                        fontWeight: "600",
                        flex: "1 1 20%",
                        borderRadius: "24px",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        boxShadow: " 0px -3px 4px 0px #00000040 inset",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (selectedPatient?.visitInfoResponse?.id) {
                          navigate({
                            pathname: `${ROUTES.ADD_NEW_OPD_BILL}/${selectedPatient?.visitInfoResponse?.id}`,
                          });
                        }
                      }}
                    >
                      OPD BILLING
                    </Button>
                  )}
                {(selectedPatient?.visitInfoResponse?.visitType?.toUpperCase() ===
                  "IP" ||
                  selectedPatient?.visitInfoResponse?.visitType?.toUpperCase() ===
                    "EMERGENCY") &&
                  hasFunctionality("ipdBillList") && (
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "#808184",
                        color: "white",
                        fontWeight: "600",
                        flex: "1 1 20%",
                        borderRadius: "24px",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        boxShadow: " 0px -3px 4px 0px #00000040 inset",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (selectedPatient?.visitInfoResponse?.id) {
                          navigate({
                            pathname: `${ROUTES.ADD_NEW_IPD_BILL}/${selectedPatient?.visitInfoResponse?.id}`,
                          });
                        }
                      }}
                    >
                      IPD BILLING
                    </Button>
                  )} */}

                  {/* {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                  "OP" ? (
                    <></>
                  ) : patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                      "CGHS NEW" ||
                    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                      "CAPF NEW" ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Button
                        type="primary"
                        icon={
                          isDischargeSubmitted ? (
                            <></>
                          ) : isPreAuthCompleted ? (
                            <PlusOutlined />
                          ) : (
                            <></>
                          )
                        }
                        style={{
                          backgroundColor: "#008B8B",
                          color: "white",
                          fontWeight: 600,
                          fontSize: "0.8rem",
                          borderRadius: "50px 0 0 50px",
                          boxShadow: "inset 0px -3px 4px 0px #00000040",
                          // padding: "0 20px",
                          // height: "48px",
                          border: "none",
                        }}
                        onClick={() => {
                          if (isPreAuthCompleted && !isDischargeSubmitted) {
                            handleResubmission();
                            setActiveKey("");
                          }
                        }}
                      >
                        RESUBMISSION
                      </Button>
                      <Button
                        type="primary"
                        icon={<EyeOutlined />}
                        style={{
                          backgroundColor: "#008B8B",
                          color: "white",
                          fontWeight: 600,
                          borderRadius: "0 50px 50px 0",
                          boxShadow: "inset 0px -3px 4px 0px #00000040",
                          // padding: "0 16px",
                          // height: "48px",
                          border: "none",
                        }}
                        onClick={viewResubmission}
                      />
                    </div>
                  ) : (
                    <></>
                  )} */}

                  {patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
                    "ECHS" &&
                  (patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                    "IP" ||
                    patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                      "EMERGENCY") ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Button
                        type="primary"
                        icon={
                          isDischargeSubmitted ? (
                            <></>
                          ) : isClaimIdGenerationCompleted ? (
                            <PlusOutlined />
                          ) : (
                            <></>
                          )
                        }
                        style={{
                          backgroundColor: "#008B8B",
                          color: "white",
                          fontWeight: 600,
                          fontSize: "0.8rem",
                          borderRadius: "50px",
                          boxShadow: "inset 0px -3px 4px 0px #00000040",
                          border: "none",
                        }}
                        onClick={() => {
                          if (
                            isClaimIdGenerationCompleted &&
                            !isDischargeSubmitted
                          ) {
                            handleCreateUnlistedProcedure();
                            setActiveKey("");
                          }
                        }}
                      >
                        UNLISTED PROCEDURE
                      </Button>
                      {/* <Button
                        type="primary"
                        icon={<EyeOutlined />}
                        style={{
                          backgroundColor: "#008B8B",
                          color: "white",
                          fontWeight: 600,
                          borderRadius: "0 50px 50px 0",
                          boxShadow: "inset 0px -3px 4px 0px #00000040",
                          border: "none",
                        }}
                        onClick={viewUnlistedProcedure}
                      /> */}
                    </div>
                  ) : (
                    <></>
                  )}

                  {patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
                    "ECHS" &&
                  (patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                    "IP" ||
                    patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                      "EMERGENCY") ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Button
                        type="primary"
                        icon={
                          isDischargeSubmitted ? (
                            <></>
                          ) : isPreauthSubmitted ? (
                            <PlusOutlined />
                          ) : (
                            <></>
                          )
                        }
                        style={{
                          backgroundColor: "#008B8B",
                          color: "white",
                          fontWeight: 600,
                          fontSize: "0.8rem",
                          borderRadius: "50px", //50px 0 0 50px
                          boxShadow: "inset 0px -3px 4px 0px #00000040",
                          border: "none",
                        }}
                        onClick={() => {
                          if (isPreauthSubmitted && !isDischargeSubmitted) {
                            handleCreateExtensionOfStay();
                            setActiveKey("");
                          }
                        }}
                      >
                        EXTENSION OF STAY
                      </Button>
                      {/* <Button
                        type="primary"
                        icon={<EyeOutlined />}
                        style={{
                          backgroundColor: "#008B8B",
                          color: "white",
                          fontWeight: 600,
                          borderRadius: "0 50px 50px 0",
                          boxShadow: "inset 0px -3px 4px 0px #00000040",
                          border: "none",
                        }}
                        onClick={viewExtensionOfStay}
                      /> */}
                    </div>
                  ) : (
                    <></>
                  )}

                  {!patients?.fetchBasicDetails?.casesResponse?.isTpa ||
                  !otNotes ? (
                    <></>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Upload
                        multiple={otNotes?.multiple}
                        // multiple={false}
                        showUploadList={false}
                        beforeUpload={() => false}
                        onChange={
                          handleFileChange && handleFileChange(otNotes?.labelId) //docType?.multiple
                        }
                        disabled={otNotes?.documentList?.length > 0}
                      >
                        <Button
                          type="primary"
                          icon={
                            otNotes?.documentList?.length === 0 ||
                            !otNotes?.documentList ? (
                              <PlusOutlined />
                            ) : null
                          }
                          style={{
                            backgroundColor: "rgb(0, 76, 143)",
                            color: "white",
                            fontWeight: 600,
                            fontSize: "0.8rem",
                            borderRadius:
                              otNotes?.documentList?.length > 0
                                ? "50px 0 0 50px"
                                : "50px",
                            boxShadow: "inset 0px -3px 4px 0px #00000040",
                            // padding: "0 20px",
                            // height: "48px",
                            border: "none",
                          }}
                        >
                          OT Notes
                        </Button>
                      </Upload>
                      {otNotes?.documentList?.length > 0 ? (
                        <Button
                          type="primary"
                          icon={<EyeOutlined />}
                          style={{
                            backgroundColor: "rgb(0, 76, 143)",
                            color: "white",
                            fontWeight: 600,
                            borderRadius:
                              otNotes?.documentList?.length > 0
                                ? "0 50px 50px 0"
                                : "0",
                            boxShadow: "inset 0px -3px 4px 0px #00000040",
                            // padding: "0 16px",
                            // height: "48px",
                            border: "none",
                          }}
                          onClick={() => {
                            handleOpenOtNotes(otNotes?.label);
                          }}
                        />
                      ) : null}
                    </div>
                  )}

                  {patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                    "OP" ||
                  patients?.fetchBasicDetails?.casesResponse?.portalMetaDataNames?.[0]?.toUpperCase() ===
                    "ECHS" ? (
                    <></>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Button
                        type="primary"
                        icon={
                          isDischargeSubmitted ? (
                            <></>
                          ) : isPreAuthCompleted ? (
                            <PlusOutlined />
                          ) : (
                            <></>
                          )
                        }
                        style={{
                          backgroundColor: "#008B8B",
                          color: "white",
                          fontWeight: 600,
                          fontSize: "0.8rem",
                          borderRadius: "50px 0 0 50px",
                          boxShadow: "inset 0px -3px 4px 0px #00000040",
                          // padding: "0 20px",
                          // height: "48px",
                          border: "none",
                        }}
                        onClick={() => {
                          if (isPreAuthCompleted && !isDischargeSubmitted) {
                            handleCreateEnhancement();
                            setActiveKey("");
                          }
                        }}
                      >
                        ENHANCEMENT
                      </Button>
                      <Button
                        type="primary"
                        icon={<EyeOutlined />}
                        style={{
                          backgroundColor: "#008B8B",
                          color: "white",
                          fontWeight: 600,
                          borderRadius: "0 50px 50px 0",
                          boxShadow: "inset 0px -3px 4px 0px #00000040",
                          // padding: "0 16px",
                          // height: "48px",
                          border: "none",
                        }}
                        onClick={viewAddedEnhancement}
                      />
                    </div>
                  )}

                  {(hasFunctionality("opdBillList") ||
                    hasFunctionality("ipdBillList")) && (
                    <div style={{ width: "16%" }}>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "#808184",
                          color: "white",
                          fontWeight: "600",
                          flex: "1 1 20%",
                          borderRadius: "24px",
                          cursor: "pointer",
                          fontSize: "0.8rem",
                          boxShadow: " 0px -3px 4px 0px #00000040 inset",
                        }}
                        onClick={() =>
                          openBillAuditForMapping(
                            patients?.fetchBasicDetails?.visitInfoResponse
                              ?.billMappingId,
                            patients?.fetchBasicDetails?.casesResponse
                              ?.healthCareId,
                            patients?.fetchBasicDetails?.casesResponse
                              ?.schemeType,
                          )
                        }
                      >
                        BILLING
                      </Button>
                    </div>
                  )}
                  {hasFunctionality("casePreAuthView") && (
                    <Button
                      style={{
                        backgroundColor: "#D51E1E",
                        color: "white",
                        fontWeight: "600",
                        flex: "1 1 20%",
                        borderRadius: "24px",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        boxShadow: " 0px -3px 4px 0px #00000040 inset",
                      }}
                      block
                      onClick={handleCreditClickModal}
                    >
                      Print Credit Note
                    </Button>
                  )}
                  {(!selectedPatient?.visitInfoResponse?.message
                    ?.toLowerCase()
                    ?.includes("discharge completed") ||
                    selectedPatient?.visitInfoResponse?.visitStageName
                      ?.toLowerCase()
                      ?.includes("claim")) &&
                  hasFunctionality("casePreAuthView") ? (
                    <Button
                      style={{
                        backgroundColor: "#D2691E",
                        color: "white",
                        fontWeight: "600",
                        flex: "1 1 20%",
                        borderRadius: "24px",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        boxShadow: " 0px -3px 4px 0px #00000040 inset",
                      }}
                      block
                      onClick={(e) => {
                        e.stopPropagation();
                        showModal();
                        // handleNavigate(
                        //   `${ROUTES.BASIC_DETAILS}/${selectedPatient?.visitInfoResponse?.id}`
                        // );
                      }}
                    >
                      Shift Patient
                    </Button>
                  ) : (
                    <></>
                  )}
                  {/* <Button
                  style={{
                    backgroundColor: "#0D99FF",
                    color: "white",
                    fontWeight: "600",
                    flex: "1 1 20%",
                    borderRadius: "24px",
                    cursor: "pointer",
                    fontSize: "0.8rem",
                    boxShadow: " 0px -3px 4px 0px #00000040 inset",
                  }}
                  block
                  onClick={(e) => {
                    e.stopPropagation();
                    showModal();
                    handleNavigate(
                      `${ROUTES.DOCUMENT_DEFICIENCY}/${selectedPatient?.casesResponse?.id}/${selectedPatient?.visitInfoResponse?.id}/${selectedPatient?.casesResponse?.schemeMetaDataId}`
                    );
                  }}
                >
                  Deficiency Check
                </Button> */}
                  {/* {isVisitEdit || isEditSchemeDetail ? (
                  <Button
                    type="primary"
                    icon={<CloseOutlined />}
                    onClick={
                      activeTab === "1"
                        ? handleEditVisitReferral
                        : handleEditSchemeDetails
                    }
                    style={{ fontSize: "0.8rem" }}
                  >
                    CANCEL
                  </Button>
                ) : (
                  ((hasFunctionality("referralEdit") &&
                    hasFunctionality("visitEdit")) ||
                    hasFunctionality("schemeEdit")) && (
                    <Button
                      style={{
                        backgroundColor: "#00549E",
                        color: "white",
                        fontWeight: "600",
                        flex: "1 1 20%",
                        borderRadius: "24px",
                        cursor: "pointer",
                        fontSize: "0.8rem",
                      }}
                      block
                      onClick={
                        activeTab === "1"
                          ? handleEditVisitReferral
                          : handleEditSchemeDetails
                      }
                    >
                      Edit
                    </Button>
                  )
                )} */}

                  {activeTab === "1" ? (
                    isVisitEdit ? (
                      <Button
                        type="primary"
                        icon={<CloseOutlined />}
                        onClick={handleEditVisitReferral}
                        style={{ fontSize: "0.8rem" }}
                      >
                        CANCEL
                      </Button>
                    ) : (
                      // hasFunctionality("referralEdit") &&
                      // hasFunctionality("visitEdit") && (
                      //   <Button
                      //     style={{
                      //       backgroundColor: "#00549E",
                      //       color: "white",
                      //       fontWeight: "600",
                      //       flex: "1 1 20%",
                      //       borderRadius: "24px",
                      //       cursor: "pointer",
                      //       fontSize: "0.8rem",
                      //       boxShadow: " 0px -3px 4px 0px #00000040 inset",
                      //     }}
                      //     block
                      //     onClick={handleEditVisitReferral}
                      //   >
                      //     Edit
                      //   </Button>
                      // )
                      <></>
                    )
                  ) : isEditSchemeDetail ? (
                    <Button
                      type="primary"
                      icon={<CloseOutlined />}
                      onClick={handleEditSchemeDetails}
                      style={{ fontSize: "0.8rem" }}
                    >
                      CANCEL
                    </Button>
                  ) : (
                    <></>
                    // hasFunctionality("schemeEdit") && (
                    //   <Button
                    //     style={{
                    //       backgroundColor: "#00549E",
                    //       color: "white",
                    //       fontWeight: "600",
                    //       flex: "1 1 20%",
                    //       borderRadius: "24px",
                    //       cursor: "pointer",
                    //       fontSize: "0.8rem",
                    //       boxShadow: " 0px -3px 4px 0px #00000040 inset",
                    //     }}
                    //     block
                    //     onClick={handleEditSchemeDetails}
                    //   >
                    //     Edit
                    //   </Button>
                    // )
                  )}
                </div>
              </div>
              {/* {patients?.fetchBasicDetails?.casesResponse?.schemeType ===
              "TPA" ? (
                // <div style={{display: "flex", alignItems: "center", gap: "0.5rem"}}>
                //   <Collapse
                //     className="patient-details-stages"
                //     bordered={false}
                //     activeKey={activeKey}
                //     onChange={(key) => setActiveKey(key)}
                //     expandIconPosition="start" // Important to bring icon start
                //     expandIcon={() => null} // Hides default expand icon
                //     items={getItems()}
                //     style={{width: "80%"}}
                //   />
                //   <Timeline
                //     caseId={
                //       selectedPatient?.casesResponse?.id
                //         ? selectedPatient?.casesResponse?.id
                //         : null
                //     }
                //     visitId={
                //       selectedPatient?.visitInfoResponse?.id
                //         ? selectedPatient?.visitInfoResponse?.id
                //         : null
                //     }
                //     isTimelineVisible={null}
                //   />
                // </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "0.5rem",
                    height: "100%",
                  }}
                >
                  <div style={{ width: "78%" }}>
                    <Collapse
                      className="patient-details-stages"
                      bordered={false}
                      activeKey={activeKey}
                      onChange={(key) => setActiveKey(key)}
                      expandIconPosition="start"
                      expandIcon={() => null}
                      items={getItems()}
                      style={{ height: "100%" }}
                      accordion
                    />
                  </div>
                  <div
                    style={{
                      width: "22%",
                      maxHeight: "20%",
                      overflowY: "auto",
                      marginTop: "1rem",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      gap: "1rem",
                    }}
                  >
                    {queries?.loading ? (
                    //   <Loader />
                    // ) : (
                    //   <PatientDetailsQueryCard
                    //     activeKey={
                    //       activeKey
                    //         ? activeKey
                    //         : stepperData?.currentVisitStage?.visitStageId
                    //     }
                    //     handleCreateQuery={handleCreateQuery}
                    //     visitStages={stepperData?.visitStages}
                    //     queries={queries?.data}
                    //     handleReplyQueryModal={handleReplyQueryModal}
                    //     handleViewQueryModal={handleViewQueryModal}
                    //   />
                    )}

                    <PatientDetailsQueryCardAllStages activeKey={
                          activeKey
                            ? activeKey
                            : stepperData?.currentVisitStage?.visitStageId
                        }
                        handleCreateQuery={handleCreateQuery}
                        visitStages={stepperData?.visitStages}
                        handleReplyQueryModal={handleReplyQueryModal}
                        handleViewQueryModal={handleViewQueryModal}
                      />
                    <Timeline
                      caseId={selectedPatient?.casesResponse?.id || null}
                      visitId={selectedPatient?.visitInfoResponse?.id || null}
                      isTimelineVisible={null}
                    />
                  </div>
                </div>
              ) : (
                <></>
              )} */}
              {/* <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "0.5rem",
                  height: "100%",
                  position: "relative",
                }}
              >
                <div
                  // style={{
                  //   width: "78%",
                  // }}
                  className="smooth-scroll-container"
                  style={{
                    width: "78%",
                    height: "100%", // Full height of parent
                    overflow: "auto",
                    paddingRight: "8px",
                    scrollBehavior: "smooth",
                    WebkitOverflowScrolling: "touch",
                    // Custom scrollbar styling
                    scrollbarWidth: "thin",
                    scrollbarColor: "#c1c1c1 #f1f1f1",
                  }}
                >
                  <Collapse
                    className="patient-details-stages"
                    bordered={false}
                    activeKey={activeKey}
                    onChange={(key) => setActiveKey(key)}
                    expandIconPosition="start"
                    expandIcon={() => null}
                    items={getItems()}
                    // style={{ height: "100%" }}
                    style={{
                      height: "auto",
                      minHeight: "100%",
                      // Optimize animations
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    }}
                    accordion
                  />
                </div>
                <div
                  style={{
                    width: "22%",
                    height: "100%", // Full height of parent
                    position: "sticky",
                    top: 0, // Stick to top of container
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    paddingLeft: "8px",
                    paddingTop: "1rem", // Add some top padding
                    overflow: "hidden", // Prevent overflow
                  }}
                  // style={{
                  //   width: "22%",
                  //   maxHeight: "20%",
                  //   overflowY: "auto",
                  //   marginTop: "1rem",
                  //   display: "flex",
                  //   flexDirection: "column",
                  //   justifyContent: "center",
                  //   gap: "1rem",
                  // }}
                >

                  <PatientDetailsQueryCardAllStages
                    activeKey={
                      activeKey
                        ? activeKey
                        : stepperData?.currentVisitStage?.visitStageId
                    }
                    handleCreateQuery={handleCreateQuery}
                    visitStages={stepperData?.visitStages}
                    handleReplyQueryModal={handleReplyQueryModal}
                    handleViewQueryModal={handleViewQueryModal}
                    setQueryStageId={setQueryStageId}
                    setActiveKey={setActiveKey}
                  />
                  <Timeline
                    caseId={selectedPatient?.casesResponse?.id || null}
                    visitId={selectedPatient?.visitInfoResponse?.id || null}
                    isTimelineVisible={null}
                  />
                </div>
              </div> */}
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "0.5rem",
                  height: "149vh", // Set a fixed height for the scroll area
                  position: "relative",
                  background: "#F9F9F9",
                  borderRadius: "20px",
                  top: "1rem",
                }}
              >
                <div
                  style={{
                    width: "78%",
                    height: "100%",
                    overflow: "auto",
                    paddingRight: "8px",
                    scrollBehavior: "smooth",
                    WebkitOverflowScrolling: "touch",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#c1c1c1 #f1f1f1",
                    background: "#F9F9F9",
                    borderRadius: "20px 0 0 20px",
                  }}
                >
                  {patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                    "CGHS NEW" ||
                  patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                    "CAPF NEW" ? (
                    <h4
                      style={{
                        color: "red",
                        fontWeight: "bold",
                        marginLeft: "20px",
                      }}
                    >
                      Note: Portal Registration needs to be done from Hospital.
                    </h4>
                  ) : (
                    <></>
                  )}
                  <Collapse
                    className="patient-details-stages"
                    bordered={false}
                    activeKey={activeKey}
                    onChange={async (key) => {
                      if (
                        !patients?.fetchBasicDetails?.visitInfoResponse
                          ?.assignedTo &&
                        patients?.fetchBasicDetails?.visitInfoResponse?.id
                      ) {
                        const res = await assignedTo(
                          patients?.fetchBasicDetails?.visitInfoResponse?.id,
                        );
                        dispatch(
                          getBasicDetails({
                            id: patients?.fetchBasicDetails?.visitInfoResponse
                              ?.id,
                          }),
                        );
                      }
                      setActiveKey(key);
                    }}
                    expandIconPosition="start"
                    expandIcon={() => null}
                    items={getItems()}
                    style={patientStagesCollapseStyle}
                    accordion
                  />
                </div>
                <div
                  style={{
                    width: "22%",
                    height: "100%",
                    overflow: "auto",
                    position: "sticky",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    background: "#F9F9F9",
                    borderRadius: "0 20px 20px 0",
                    zIndex: 2,
                    top: "1rem",
                  }}
                >
                  <div>
                    <PatientDetailsQueryCardAllStages
                      activeKey={
                        activeKey
                          ? activeKey
                          : stepperData?.currentVisitStage?.visitStageId
                      }
                      handleCreateQuery={handleCreateQuery}
                      visitStages={stepperData?.visitStages}
                      handleReplyQueryModal={handleReplyQueryModal}
                      handleViewQueryModal={handleViewQueryModal}
                      setQueryStageId={setQueryStageId}
                      setActiveKey={setActiveKey}
                    />
                  </div>
                  <div>
                    <Timeline
                      caseId={selectedPatient?.casesResponse?.id || null}
                      visitId={selectedPatient?.visitInfoResponse?.id || null}
                      isTimelineVisible={null}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        </Space>
      </Row>

      <DeficiencyUploadModal
        visible={replyDeficiencyQueryModal}
        onClose={() => setReplyDeficiencyQueryModal(false)}
        replyQuery={replyQuery}
        handleOpen={handleOpen}
        documentUrls={documentUrls}
        handleFileChange={handleFileChange}
        isReplying={isReplying}
        handleSubmit={handleSubmitDocumentDeficiencyQuery}
        setResponseRemark={setResponseRemark}
        responseRemark={responseRemark}
        handleViewDeficiencyFailedDocument={handleViewDeficiencyFailedDocument}
      />
      <UploadQueryModal
        visible={replyQueryModal}
        onClose={() => setReplyQueryModal(false)}
        replyQuery={replyQuery}
        handleOpen={handleOpen}
        documentUrls={documentUrls}
        handleFileChange={handleFileChange}
        isReplying={isReplying}
        handleSubmit={handleSubmit}
        setResponseRemark={setResponseRemark}
        responseRemark={responseRemark}
      />

      <ViewQueryDocumentDeficiencyModal
        visible={viewDeficiencyQueryModal}
        onClose={() => setViewDeficiencyQueryModal(false)}
        viewedQuery={viewedQuery}
        handleOpenUploadedDocument={handleOpenUploadedDocument}
        handleViewDeficiencyFailedDocument={handleViewDeficiencyFailedDocument}
      />
      <ViewQueryModal
        visible={viewQueryModal}
        onClose={() => setViewQueryModal(false)}
        viewedQuery={viewedQuery}
        handleOpenUploadedDocument={handleOpenUploadedDocument}
        handleGetData={handleGetData}
      />

      {viewedQuery ? (
        <ViewQueryUploadedDocument
          open={viewUploadedDocument}
          handleCancel={() => setViewUploadedDocument(false)}
          handleDownloadDocument={handleDownloadDocument}
          handleDeficiencyModal={handleDeficiencyModal}
          deficiencyQuestions={deficiencyQuestions}
          setDocumentName={setDocumentName}
          selectedDocument={selectedDocument}
          documents={viewedQuery?.returnedDocumentUrl}
          activeKey={activeKey}
          queryStageId={queryStageId}
          clickedActiveTab={clickedActiveTab}
        />
      ) : (
        <></>
      )}

      <FilePreviewModal
        isVisible={previewModalVisible}
        onClose={() => setPreviewModalVisible(false)}
        fileUrl={previewFile.url}
        fileName={previewFile.name}
        documentType={previewFile.documentType}
        handleUpload={handleUpload}
        showUploadButton={previewFile.showUpload}
        key={selectedFile?.file?.lastModified || "no-file"}
        isLoading={enhancement?.isLoading}
      />

      <QueryUploadedDocument
        // key={documentUrl}
        handleCancel={handleCancelPreview}
        handleDeleteDocument={handleDeleteList}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        // handleSetDocumentUrl={handleSetDocumentUrl}
        documents={documentUrls}
        handleDeficiencyModal={handleDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
        activeKey={activeKey}
        queryStageId={queryStageId}
        clickedActiveTab={clickedActiveTab}
      />

      {viewDeficiencyFailedDocument?.oldDocument ? (
        <DeficiencyFailedDocumentView
          open={deficiencyFailedDocument}
          handleCancel={() => setDeficiencyFailedDocument(false)}
          handleDownloadDocument={handleDownloadDocument}
          handleDeficiencyModal={handleDeficiencyModal}
          deficiencyQuestions={deficiencyQuestions}
          setDocumentName={setDocumentName}
          selectedDocument={selectedDocument}
          document={viewDeficiencyFailedDocument?.oldDocument}
        />
      ) : (
        <></>
      )}

      {!flag && (
        <FloatingDrawer
          schemeMetaDataId={
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
          }
          schemeMetaDataName={
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName
          }
          caseId={patients?.fetchBasicDetails?.casesResponse?.id}
          visitId={patients?.fetchBasicDetails?.visitInfoResponse?.id}
          stepNumber={preAuth?.currentStep}
        />
      )}

      {/* <PortalActiveInActiveModal
        open={portalInactiveModalOpen}
        onClose={() => setPortalInactiveModalOpen(false)}
      /> */}

      <ConfirmModal
        flagForPatientReg={false}
        isModalOpen={isActiveDeactiveModal}
        setIsModalOpen={setIsActiveDeactiveModal}
        handleOk={handleOk}
        handleCancel={handleCancelConfirmationModal}
        isReferralLoading={isSubmitting}
        message={`Do you want to ${
          selectedPatient?.visitInfoResponse?.status ? "DEACTIVATE" : "ACTIVATE"
        } the case`}
        patientFormData={true}
      />

      {previewDocumentOtNotes && (
        <PatientDetailsStageDocument
          handleCancel={() => setPreviewDocumentOtNotes(false)}
          handleDeleteDocument={handleDeleteListOtNotes}
          open={previewDocumentOtNotes}
          handleDownloadDocument={handleDownloadDocument}
          documents={otNotes?.documentList || []}
          handleDeficiencyModal={handleDeficiencyModal}
          closeDeficiencyModal={closeDeficiencyModal}
          deficiencyModal={deficiencyModal}
          deficiencyQuestions={patients?.deficiencyCheckQuestions}
          setDocumentName={setDocumentName}
          selectedDocument={selectedDocument}
          activeKey={activeKey}
          clickedActiveTab={clickedActiveTab}
        />
      )}
    </div>
  );
};

export default React.memo(PatientDetailsForm);
